var _path, _path2, _polygon, _circle, _circle2, _circle3, _circle4, _path3, _rect, _rect2, _rect3, _rect4, _polygon2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-204"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.19,
    y: 358.88,
    width: 132.8,
    height: 54.63,
    rx: 11.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.46,413.51a14.34,14.34,0,0,0,3.53-.62,11.49,11.49,0,0,0,7.14-6.89,10.73,10.73,0,0,0,.69-3.43c.06-1.23,0-2.55,0-3.91,0-2.73,0-5.7,0-8.89s0-6.61,0-10.22c0-1.81,0-3.67,0-5.58a36.66,36.66,0,0,0-.23-5.82,11.38,11.38,0,0,0-8-8.6c-2.06-.63-4.32-.39-6.6-.43h-7l-30.15,0-69.09,0a11.23,11.23,0,0,0-11.24,11.27v17.63q0,4.34,0,8.59v4.23a13.49,13.49,0,0,0,.42,4.08,11.3,11.3,0,0,0,4.61,6.37,10.82,10.82,0,0,0,3.61,1.56,15.06,15.06,0,0,0,3.92.32l56.43.07,38,.09,10.34.06,2.69,0,.92,0-.92,0-2.69,0-10.34.06-38,.1-56.43.06a15.91,15.91,0,0,1-4-.33,11.43,11.43,0,0,1-3.8-1.63,11.88,11.88,0,0,1-4.85-6.7,14.11,14.11,0,0,1-.44-4.23v-4.23q0-4.26,0-8.59V370.45a11.85,11.85,0,0,1,11.84-11.88l69.09,0,30.15,0h10.35a12.08,12.08,0,0,1,3.34.46,11.84,11.84,0,0,1,8.31,9,15.34,15.34,0,0,1,.23,3c0,1,0,1.95,0,2.91,0,1.91,0,3.77,0,5.58,0,3.61,0,7,0,10.22s0,6.16,0,8.89c0,1.37,0,2.67,0,3.93a11.12,11.12,0,0,1-.74,3.49A11.55,11.55,0,0,1,271,413a12.64,12.64,0,0,1-2.65.49C267.77,413.52,267.46,413.51,267.46,413.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,389.77H195.2a4.08,4.08,0,0,1-4.08-4.08h0a4.09,4.09,0,0,1,4.08-4.09H256a4.09,4.09,0,0,1,4.09,4.09h0A4.09,4.09,0,0,1,256,389.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.77,
    y: 376.74,
    width: 18.92,
    height: 18.92,
    rx: 5.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.69 386.47 169.6 384.56 173.27 387.83 179.41 381.67 181.18 383.57 173 391.5 167.69 386.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.84,123.08A9.08,9.08,0,1,1,668,116.26,9.08,9.08,0,0,1,678.84,123.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,133.06l68-15.63-5.93-4.32a18.84,18.84,0,0,1-7.28-11l-4.23-18.46a25.46,25.46,0,0,0-30.5-19.1h0A25.44,25.44,0,0,0,637,95l4.07,17.75A18.84,18.84,0,0,1,639.78,125Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.76,
    y: 56.53,
    width: 6.85,
    height: 14.56,
    rx: 2.98,
    transform: "translate(2.35 148.31) rotate(-12.94)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.09,117.58c0,.14-15.07,3.72-33.73,8s-33.82,7.64-33.86,7.5,15.07-3.73,33.74-8S704.06,117.43,704.09,117.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.21,127.41a15.18,15.18,0,0,0,9.27,1.09,14.52,14.52,0,0,0,8.42-5.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.48,81.21a5,5,0,0,0-1-2.17,1.77,1.77,0,0,0-2.18-.43h0a1.89,1.89,0,0,0-1.07,2.16c.66,2.92,2.1,9.37,2.82,13.24.59,3.19.92,6.66-.56,9.54a10.84,10.84,0,0,1-5.61,4.77,40.79,40.79,0,0,1-7.25,1.94,38.47,38.47,0,0,0-9,2.87,4.75,4.75,0,0,0-2,1.54,1.85,1.85,0,0,0,.16,2.32,2.77,2.77,0,0,0,2.23.33c7.91-1.09,15.87-2.33,23.39-5a8.05,8.05,0,0,0,4.13-2.63c1.07-1.55,1-3.59.81-5.47A130.38,130.38,0,0,0,682.48,81.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.67,70.47l.06,0,.08,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M671.56,65.69c0,.1-1.54-.55-4.09-1.06a26.74,26.74,0,0,0-4.53-.5,31.23,31.23,0,0,0-5.55.42A30.8,30.8,0,0,0,652,66.08a27.13,27.13,0,0,0-4.08,2c-2.22,1.36-3.4,2.48-3.47,2.4s.26-.32.8-.82a11.91,11.91,0,0,1,1-.86c.42-.31.88-.7,1.44-1a25.3,25.3,0,0,1,4.1-2.17A28.16,28.16,0,0,1,657.3,64a28.83,28.83,0,0,1,5.66-.39,24.64,24.64,0,0,1,4.59.62,15.23,15.23,0,0,1,1.71.47,10.43,10.43,0,0,1,1.27.46A4.22,4.22,0,0,1,671.56,65.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.36,123.64c-.15-.06.72-2.19,1-5s0-5,.16-5.08a13.73,13.73,0,0,1-1.2,10Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.64,132a2.88,2.88,0,0,1-1.37.65,7,7,0,0,1-6.83-1.86c-.66-.69-.9-1.23-.85-1.26s.42.4,1.1,1a8.14,8.14,0,0,0,3,1.63,7.93,7.93,0,0,0,3.45.14A9.94,9.94,0,0,1,672.64,132Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.74,57.8a15.32,15.32,0,0,0-.63,2.47,16.13,16.13,0,0,0,.3,2.53,3.67,3.67,0,0,1,.33-5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.42,155.11a26.75,26.75,0,0,1,6.51-2.82l1.34-6.44,10.87-.19,1.57,6.38a26.92,26.92,0,0,1,6.59,2.6l5.5-3.6,7.83,7.55-3.41,5.62a27.17,27.17,0,0,1,2.83,6.51l6.43,1.34.19,10.87-6.38,1.57a26.53,26.53,0,0,1-2.6,6.59l3.6,5.5-7.55,7.83L122.12,201a27.28,27.28,0,0,1-6.5,2.83l-1.34,6.43-10.88.19-1.56-6.38a26.59,26.59,0,0,1-6.6-2.6l-5.5,3.6-7.82-7.55,3.4-5.62a26.85,26.85,0,0,1-2.82-6.5l-6.44-1.34-.19-10.88,6.38-1.56a27,27,0,0,1,2.6-6.6l-3.6-5.5,7.55-7.82,5.62,3.4Zm5.8,14.49a11.67,11.67,0,1,0,16.5-.29A11.66,11.66,0,0,0,100.22,169.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.42,285.74a21.58,21.58,0,0,1,5.2-2.26l1.07-5.14,8.68-.15,1.25,5.1a21.4,21.4,0,0,1,5.27,2.07l4.39-2.87,6.26,6L722.81,293a20.91,20.91,0,0,1,2.26,5.19l5.14,1.07.16,8.69-5.11,1.25a20.64,20.64,0,0,1-2.07,5.27l2.88,4.39-6,6.25-4.48-2.72a21.52,21.52,0,0,1-5.2,2.26l-1.07,5.14-8.69.15-1.25-5.1a21.55,21.55,0,0,1-5.27-2.07l-4.39,2.88-6.25-6,2.72-4.49a21.26,21.26,0,0,1-2.25-5.19l-5.15-1.07-.15-8.69,5.1-1.25a21.19,21.19,0,0,1,2.08-5.27l-2.88-4.39,6-6.25,4.49,2.72Zm4.63,11.57a9.32,9.32,0,1,0,13.18-.23A9.33,9.33,0,0,0,698.05,297.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.12,284a13.69,13.69,0,0,1,3.36-1.46l.69-3.32,5.62-.1.8,3.29A13.82,13.82,0,0,1,69,283.77l2.84-1.85,4,3.9-1.76,2.9a13.79,13.79,0,0,1,1.46,3.35l3.32.69.1,5.62-3.3.81a13.52,13.52,0,0,1-1.34,3.4l1.86,2.84-3.9,4-2.9-1.76a13.69,13.69,0,0,1-3.36,1.46l-.69,3.32-5.61.1L59,309.3A14,14,0,0,1,55.54,308l-2.83,1.86-4-3.91,1.75-2.9A13.76,13.76,0,0,1,49,299.66L45.64,299l-.1-5.62,3.3-.81a13.91,13.91,0,0,1,1.34-3.4l-1.86-2.84,3.9-4,2.9,1.76Zm3,7.48a6,6,0,1,0,8.51-.15A6,6,0,0,0,58.12,291.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77,53.11a31.36,31.36,0,0,1,7.53-3.27l1.55-7.44,12.58-.22,1.81,7.38a30.61,30.61,0,0,1,7.64,3l6.36-4.17,9.05,8.74-3.94,6.5a30.76,30.76,0,0,1,3.27,7.53l7.45,1.55.22,12.58-7.39,1.82a31.05,31.05,0,0,1-3,7.63l4.17,6.36-8.75,9.06-6.5-3.94a31,31,0,0,1-7.52,3.26l-1.55,7.45-12.59.22-1.81-7.38a31,31,0,0,1-7.64-3l-6.36,4.17-9.05-8.74,3.94-6.5A30.76,30.76,0,0,1,254,88.17l-7.45-1.55L246.3,74l7.39-1.81a31.05,31.05,0,0,1,3-7.63l-4.16-6.36,8.74-9.06,6.5,3.94Zm6.71,16.77a13.5,13.5,0,1,0,19.09-.34A13.49,13.49,0,0,0,274.48,69.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.33,369.69a30.69,30.69,0,0,1,7.52-3.27L621.4,359l12.59-.22,1.81,7.39a30.61,30.61,0,0,1,7.64,3L649.8,365l9.05,8.74-3.94,6.5a30.76,30.76,0,0,1,3.27,7.53l7.45,1.55.22,12.58-7.39,1.81a30.61,30.61,0,0,1-3,7.64l4.17,6.36-8.74,9.06-6.5-3.95a30.59,30.59,0,0,1-7.53,3.27l-1.55,7.45-12.58.22-1.81-7.39a31,31,0,0,1-7.64-3l-6.36,4.17-9-8.75,3.94-6.5a30.69,30.69,0,0,1-3.27-7.52l-7.45-1.55-.22-12.59,7.39-1.81a30.75,30.75,0,0,1,3-7.63l-4.17-6.37,8.74-9.05,6.51,3.94ZM619,386.46a13.5,13.5,0,1,0,19.09-.34A13.5,13.5,0,0,0,619,386.46Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692,465.94c0,.14-143.71.26-320.94.26s-321-.12-321-.26,143.68-.26,321-.26S692,465.79,692,465.94Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--office-plan--inject-204"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.76,
    y: 91.29,
    width: 307.15,
    height: 253.52,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.91,344.81c0-1.82-.08-100.73-.21-253.52l.21.22-307.12,0h0l.26-.26c0,91.76,0,178.36,0,253.52l-.23-.23,307.15.23L109.76,345h-.23v-.23c0-75.16,0-161.76,0-253.52V91h.29l307.12,0h.22v.22C417,244.08,416.92,343,416.91,344.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.47,328.66H123.58v-220H397.47Zm-272.89-1H396.47v-218H124.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.53,
    y: 110.05,
    width: 1,
    height: 218.14,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,110.05a2.87,2.87,0,0,1,.07.62c0,.4,0,1,.1,1.76a26.29,26.29,0,0,0,1.26,6.32,21,21,0,0,0,5,8.06,26.31,26.31,0,0,0,9.87,6.11,30.1,30.1,0,0,0,6.14,1.52l-.28.26c0-6.81.07-12.77.09-17.11,0-2.09.06-3.78.08-5,0-.55,0-1,0-1.35a1.34,1.34,0,0,1,.05-.47,2.15,2.15,0,0,1,0,.47c0,.36,0,.8,0,1.35,0,1.24,0,2.93.08,5,0,4.34.05,10.3.09,17.11V135l-.28,0a30.2,30.2,0,0,1-6.27-1.54,26.5,26.5,0,0,1-10-6.26,21.09,21.09,0,0,1-5-8.28,25,25,0,0,1-1.12-6.43c0-.77,0-1.37,0-1.77A3.69,3.69,0,0,1,216.56,110.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,157.07a2.69,2.69,0,0,1-.62,0c-.4,0-1,0-1.77,0a25,25,0,0,1-6.43-1.12,21,21,0,0,1-8.28-5,26.43,26.43,0,0,1-6.26-10,30,30,0,0,1-1.54-6.27l0-.28h.29l17.11.09,5,.08,1.35,0a1.74,1.74,0,0,1,.47,0,2.15,2.15,0,0,1-.47,0l-1.35,0-5,.07-17.11.09.26-.28a30.18,30.18,0,0,0,1.52,6.15,26.26,26.26,0,0,0,6.11,9.86,20.89,20.89,0,0,0,8.06,5,26.91,26.91,0,0,0,6.32,1.27c.76.07,1.36.06,1.76.1A2.6,2.6,0,0,1,311,157.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.67,278.72a3,3,0,0,1-.62,0c-.4,0-1,0-1.77,0a25,25,0,0,1-6.43-1.11,21.21,21.21,0,0,1-8.28-5,26.44,26.44,0,0,1-6.25-10,30.23,30.23,0,0,1-1.55-6.27l0-.29H287l17.1.09,5,.07,1.34,0a2.48,2.48,0,0,1,.47.05,1.74,1.74,0,0,1-.47,0l-1.34,0-5,.08-17.1.09.25-.28a30.14,30.14,0,0,0,1.53,6.14,26.29,26.29,0,0,0,6.1,9.86,21,21,0,0,0,8.06,5,27.42,27.42,0,0,0,6.32,1.26c.76.07,1.36.07,1.76.1A2.5,2.5,0,0,1,311.67,278.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,110.05a3.69,3.69,0,0,1,0,.62c0,.4,0,1,0,1.77a24.52,24.52,0,0,1-1.11,6.43,21.09,21.09,0,0,1-5,8.28,26.58,26.58,0,0,1-10,6.26,30.2,30.2,0,0,1-6.27,1.54l-.28,0v-.29c0-6.81.07-12.77.09-17.11,0-2.09.06-3.78.07-5,0-.55,0-1,0-1.35a2.15,2.15,0,0,1,0-.47,1.74,1.74,0,0,1,0,.47c0,.36,0,.8,0,1.35,0,1.24,0,2.93.08,5,0,4.34.05,10.3.09,17.11l-.28-.26a30.1,30.1,0,0,0,6.14-1.52,26.31,26.31,0,0,0,9.87-6.11,21.14,21.14,0,0,0,5-8.06,26.29,26.29,0,0,0,1.26-6.32c.08-.76.07-1.36.1-1.76A2.87,2.87,0,0,1,216.56,110.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.74,228s0-.15,0-.43,0-.72,0-1.25c0-1.12,0-2.74,0-4.83,0-4.21,0-10.33-.07-18,0-15.35-.07-36.95-.12-62l.25.25H339.37l.26-.26c0,33.77-.06,64.35-.08,86.54l-.18-.18,26.56.1,7.25,0,1.9,0,.66,0s-.21,0-.62,0l-1.87,0-7.21,0-26.67.1h-.18V228c0-22.19,0-52.77-.07-86.54v-.26h.27l36.36,0H376v.24c-.05,25.15-.09,46.8-.12,62.2,0,7.65-.05,13.74-.07,17.94,0,2.07,0,3.67,0,4.78,0,.52,0,.93,0,1.22S375.74,228,375.74,228Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.79,214.77a1.19,1.19,0,0,1-.08.7,1.82,1.82,0,0,1-1.59,1.19c-1.73.05-4.2.07-7.21.1h-.21v-.21c0-4,0-8.81-.05-14.06v-2.05h6.92a3.29,3.29,0,0,1,1.1.12,2,2,0,0,1,.92.65,2.08,2.08,0,0,1,.42,1c0,.38,0,.66,0,1,0,.63,0,1.24,0,1.83,0,1.17,0,2.27,0,3.27,0,1.94-.06,3.53-.08,4.72,0,.5,0,.92-.05,1.27a1.27,1.27,0,0,1,0,.45,2.39,2.39,0,0,1-.05-.45c0-.35,0-.77,0-1.27,0-1.19-.05-2.78-.08-4.72,0-1,0-2.1,0-3.27,0-.59,0-1.2,0-1.83,0-.3,0-.66,0-.93a1.56,1.56,0,0,0-1-1.27,2.54,2.54,0,0,0-.94-.08h-6.66l.26-.26v1.79c0,5.25,0,10.11-.05,14.06l-.21-.21,7.2.08a1.71,1.71,0,0,0,1.49-1A4.06,4.06,0,0,0,384.79,214.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,216.55a59.78,59.78,0,0,1-.26-8,59.68,59.68,0,0,1,.26-8,61.78,61.78,0,0,1,.26,8A61.88,61.88,0,0,1,381.15,216.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.79,179.61a1.19,1.19,0,0,1-.08.7,1.84,1.84,0,0,1-1.59,1.2c-1.73,0-4.2.07-7.21.09h-.21v-.21c0-3.95,0-8.81-.05-14.06v-2h6.92a3.29,3.29,0,0,1,1.1.12,2,2,0,0,1,1.34,1.67c0,.38,0,.66,0,1,0,.63,0,1.24,0,1.83,0,1.17,0,2.27,0,3.27,0,1.94-.06,3.53-.08,4.72,0,.5,0,.92-.05,1.27a1.27,1.27,0,0,1,0,.45,2.39,2.39,0,0,1-.05-.45c0-.35,0-.77,0-1.27,0-1.19-.05-2.78-.08-4.72,0-1,0-2.1,0-3.27,0-.59,0-1.2,0-1.83,0-.3,0-.66,0-.93a1.56,1.56,0,0,0-1-1.27,2.77,2.77,0,0,0-.94-.08h-6.66l.26-.26v1.78c0,5.25,0,10.11-.05,14.06l-.21-.21,7.2.09a1.74,1.74,0,0,0,1.49-1A4.3,4.3,0,0,0,384.79,179.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,181.39a59.68,59.68,0,0,1-.26-7.95,59.78,59.78,0,0,1,.26-8,61.88,61.88,0,0,1,.26,8A61.78,61.78,0,0,1,381.15,181.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.63,132.56a1.23,1.23,0,0,1,.71.08,1.82,1.82,0,0,1,1.19,1.59c.05,1.74.07,4.2.1,7.21v.21h-.21l-14.06,0h-2.05v-.26c0-1.55,0-3.06,0-4.52,0-.72,0-1.44,0-2.14a2.88,2.88,0,0,1,.12-1.1,2.07,2.07,0,0,1,.65-.92,2.14,2.14,0,0,1,1-.42c.37,0,.66,0,1,0h1.83l3.27,0,4.71.08,1.28,0a1.18,1.18,0,0,1,.44.05,1.53,1.53,0,0,1-.44.05l-1.28,0-4.71.08-3.27,0H353.1c-.3,0-.66,0-.93,0a1.53,1.53,0,0,0-1.27,1,2.54,2.54,0,0,0-.08.94v2.14c0,1.46,0,3,0,4.52l-.26-.26h1.79l14.06,0-.21.21c0-2.94.06-5.39.08-7.2a1.71,1.71,0,0,0-1-1.49A3.69,3.69,0,0,0,364.63,132.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.42,136.21a61.88,61.88,0,0,1-8,.26,61.78,61.78,0,0,1-7.95-.26,59.68,59.68,0,0,1,7.95-.26A59.78,59.78,0,0,1,366.42,136.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,236.87a1.22,1.22,0,0,1-.71-.08,1.84,1.84,0,0,1-1.19-1.59c0-1.74-.07-4.2-.09-7.22v-.21h.22l14.06-.05h2V228c0,1.55,0,3.07,0,4.52v2.14a3.29,3.29,0,0,1-.12,1.1,2,2,0,0,1-.66.92,1.92,1.92,0,0,1-1,.42c-.38,0-.66,0-1,0H362l-3.28,0L354,237l-1.27-.05a1.57,1.57,0,0,1-.45,0,1.57,1.57,0,0,1,.45-.05l1.27,0,4.71-.08,3.28,0h1.82c.31,0,.66,0,.93,0a1.6,1.6,0,0,0,.78-.33,1.56,1.56,0,0,0,.5-.71,2.83,2.83,0,0,0,.08-1c0-.7,0-1.41,0-2.14,0-1.45,0-3,0-4.52l.26.26h-1.78l-14.06-.05.21-.21c0,3-.07,5.4-.09,7.21a1.76,1.76,0,0,0,1,1.49A4.3,4.3,0,0,0,352.29,236.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.51,233.22a61.78,61.78,0,0,1,7.95-.26,61.88,61.88,0,0,1,8,.26,59.78,59.78,0,0,1-8,.26A59.68,59.68,0,0,1,350.51,233.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.35,167.26a1.19,1.19,0,0,1,.08-.7,1.82,1.82,0,0,1,1.59-1.19c1.74-.05,4.2-.07,7.22-.1h.21v.21c0,4,0,8.81.05,14.06v2h-6.92a3.37,3.37,0,0,1-1.11-.12,2,2,0,0,1-1.33-1.67c0-.38,0-.66,0-1,0-.63,0-1.24,0-1.83,0-1.17,0-2.27,0-3.27,0-1.94.06-3.53.08-4.72,0-.5,0-.92.05-1.27a.23.23,0,1,1,.1,0c0,.35,0,.77.05,1.27,0,1.19,0,2.78.08,4.72,0,1,0,2.1,0,3.27,0,.59,0,1.2,0,1.83,0,.3,0,.66,0,.93a1.56,1.56,0,0,0,.33.77,1.49,1.49,0,0,0,.71.5,2.81,2.81,0,0,0,.95.08h6.66l-.26.25v-1.78c0-5.25,0-10.11,0-14.06l.22.21L332,165.6a1.76,1.76,0,0,0-1.49,1A4.3,4.3,0,0,0,330.35,167.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,165.48a61.78,61.78,0,0,1,.26,8,61.88,61.88,0,0,1-.26,8,59.78,59.78,0,0,1-.26-8A59.68,59.68,0,0,1,334,165.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.35,202.42a1.19,1.19,0,0,1,.08-.7,1.84,1.84,0,0,1,1.59-1.2c1.74,0,4.2-.07,7.22-.09h.21v.21c0,4,0,8.81.05,14.06v2h-6.91a3.37,3.37,0,0,1-1.11-.12,2.09,2.09,0,0,1-.92-.66,2,2,0,0,1-.41-1c0-.38,0-.66,0-1,0-.62,0-1.23,0-1.82,0-1.17,0-2.27,0-3.27,0-1.94.06-3.53.08-4.72,0-.5,0-.92.05-1.27a.23.23,0,1,1,.1,0c0,.35,0,.77.05,1.27,0,1.19,0,2.78.08,4.72,0,1,0,2.1,0,3.27,0,.59,0,1.2,0,1.82,0,.31,0,.67,0,.94a1.56,1.56,0,0,0,.33.77,1.49,1.49,0,0,0,.71.5,2.81,2.81,0,0,0,.95.08h6.66l-.26.26V214.7c0-5.25,0-10.11,0-14.06l.22.21-7.21-.09a1.76,1.76,0,0,0-1.49,1A4.3,4.3,0,0,0,330.35,202.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,200.64a61.78,61.78,0,0,1,.26,8,61.88,61.88,0,0,1-.26,8,59.78,59.78,0,0,1-.26-8A59.68,59.68,0,0,1,334,200.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.34,300.63s.29,0,.81-.16a3.73,3.73,0,0,0,1.91-1.2,3.65,3.65,0,0,0,.73-1.43,7.33,7.33,0,0,0,.11-1.92c0-1.43,0-3,0-4.76l.22.23-12.1,0h-3.74l.25-.26c0,1.42,0,2.79,0,4.11,0,.66,0,1.33,0,1.92a3.52,3.52,0,0,0,.55,1.63,3.57,3.57,0,0,0,2.65,1.6c1,0,2,0,2.92,0l4.2.08a10.34,10.34,0,0,1,1.53.09,8.08,8.08,0,0,1-1.53.1l-4.2.07c-.9,0-1.86,0-3,0a4,4,0,0,1-3-1.75,3.9,3.9,0,0,1-.64-1.84c0-.67,0-1.29,0-2,0-1.32,0-2.69,0-4.11v-.25h4l12.1,0h.23v.22c0,1.74,0,3.33-.05,4.76a7.36,7.36,0,0,1-.16,2,3.82,3.82,0,0,1-.85,1.51,3.72,3.72,0,0,1-2.07,1.17,3.2,3.2,0,0,1-.62.05C364.41,300.65,364.34,300.65,364.34,300.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.08,297a61.78,61.78,0,0,1-7.95.26,61.88,61.88,0,0,1-8-.26,59.78,59.78,0,0,1,8-.26A59.68,59.68,0,0,1,368.08,297Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.57,307.45l.26,0,.74,0,2.9,0,10.94-.07-.15.14c0-4.5,0-10-.05-16.29V291h.2l34.85,0-.26.25c0-5.26,0-10.71,0-16.29l.27.26h-.36l-50-.05.2-.21c0,9.93-.06,18.07-.09,23.75,0,2.81,0,5,0,6.54q0,1.09,0,1.71c0,.39,0,.58,0,.58s0-.19,0-.58,0-1,0-1.71c0-1.53,0-3.73-.06-6.54,0-5.68-.05-13.82-.09-23.75v-.2h.21l50-.06h.62v.26c0,5.58,0,11,0,16.29v.26h-.25l-34.85-.05.2-.21c0,6.27,0,11.8-.05,16.29v.15h-.15l-10.94-.07-2.9,0-.74,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.5,
    y: 253.74,
    width: 84.69,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.77,
    y: 105.49,
    width: 47.16,
    height: 5.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.92,111.4s0-.14,0-.4,0-.67,0-1.15c0-1,0-2.48-.06-4.36l.11.12c-8.56.08-26.48.14-47.15.14h0c-.24.23.31-.32.26-.26h0v3c0,1,0,2,0,2.91l-.25-.26,33.45.11,10,.08,2.72,0h.72l.25,0s-.07,0-.22,0l-.68,0-2.67,0-9.95.08-33.63.11h-.26v-6.15h0c-.06.05.49-.5.26-.26h0c20.67,0,38.59.06,47.15.14H240v.12c0,1.91,0,3.39-.07,4.43,0,.47,0,.84,0,1.12A1.44,1.44,0,0,1,239.92,111.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.53,
    y: 130.01,
    width: 5.91,
    height: 31.74,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53,161.76l.42,0,1.17,0,4.33-.08-.14.14c-.08-6.61-.12-18.36-.12-31.74h0l.26.26h-5.92l.26-.26c-.05,8.94-.09,16.82-.11,22.54,0,2.81-.06,5.09-.08,6.72,0,.76,0,1.36,0,1.83a4.79,4.79,0,0,1,0,.66,4.35,4.35,0,0,1,0-.6c0-.45,0-1,0-1.77,0-1.62,0-3.87-.07-6.66,0-5.76-.07-13.71-.11-22.72v-.25h6.18l.26.26h0c0,13.38,0,25.13-.12,31.74v.14h-.13l-4.42-.08-1.13,0A2.37,2.37,0,0,1,307.53,161.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.53,
    y: 254,
    width: 5.91,
    height: 31.74,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53,285.74l.42,0,1.17,0,4.33-.08-.14.14c-.08-6.6-.12-18.36-.12-31.74h0l.26.26h-5.92l.26-.26c-.05,8.94-.09,16.82-.11,22.53,0,2.82-.06,5.09-.08,6.72q0,1.14,0,1.83a4.62,4.62,0,0,1,0,.66,4.08,4.08,0,0,1,0-.59c0-.45,0-1,0-1.77,0-1.62,0-3.88-.07-6.66,0-5.76-.07-13.71-.11-22.72v-.26h6.18l.26.26h0c0,13.38,0,25.14-.12,31.74v.14h-.13L309,285.8l-1.13,0A1.59,1.59,0,0,1,307.53,285.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.95,
    y: 169.73,
    width: 1,
    height: 37.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.01,
    y: 169.44,
    width: 1,
    height: 39.6,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.91,
    y: 188.59,
    width: 126.43,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.89,
    y: 168.85,
    width: 1,
    height: 40.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,156.84a1.31,1.31,0,0,1,.7.08,1.83,1.83,0,0,1,1.19,1.59c.05,1.74.07,4.21.1,7.22v.21h-.21l-14.06.05h-2v-4.78c0-.73,0-1.44,0-2.14a3.29,3.29,0,0,1,.12-1.1,2,2,0,0,1,.65-.92,2,2,0,0,1,1-.42c.38,0,.66,0,1,0h1.83l3.27,0,4.72.09,1.27,0a2.39,2.39,0,0,1,.45.05,1.27,1.27,0,0,1-.45,0l-1.27.05-4.72.08-3.27,0h-1.83c-.3,0-.66,0-.93,0a1.56,1.56,0,0,0-.77.33,1.54,1.54,0,0,0-.5.71,2.83,2.83,0,0,0-.08.95c0,.7,0,1.41,0,2.14,0,1.46,0,3,0,4.52l-.26-.26h1.78l14.06.05-.21.21c0-2.95.06-5.4.09-7.2a1.74,1.74,0,0,0-1-1.49A3.87,3.87,0,0,0,189,156.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.32,183.29a2.4,2.4,0,0,1,0-.33c0-.24,0-.55,0-.93,0-.84,0-2-.05-3.52,0-3.06-.06-7.42-.1-12.78l.19.19-36.19.07.26-.26h0v9c0,2.93,0,5.78,0,8.5l-.25-.25,25.93.12,7.52.07,2,0h.53l.19,0a5.27,5.27,0,0,1-.66,0l-2,0-7.47.06-26.09.12h-.24v-.24c0-2.72,0-5.57,0-8.5,0-1.47,0-3,0-4.48v-4.57h0l.26-.26,36.19.07h.19v.19c0,5.41-.08,9.81-.1,12.9,0,1.48,0,2.64,0,3.47,0,.37,0,.66,0,.9A1.64,1.64,0,0,1,201.32,183.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,160.49a61.78,61.78,0,0,1-8,.26,61.88,61.88,0,0,1-8-.26,61.88,61.88,0,0,1,8-.26A61.78,61.78,0,0,1,190.74,160.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,156.84a1.35,1.35,0,0,1,.71.08,1.83,1.83,0,0,1,1.19,1.59c.05,1.74.07,4.21.1,7.22v.21h-.21l-14.06.05h-2.05v-.26c0-1.55,0-3.06,0-4.52,0-.73,0-1.44,0-2.14a2.84,2.84,0,0,1,.12-1.1,2,2,0,0,1,1.67-1.34c.37,0,.66,0,1,0h1.83l3.27,0,4.71.09,1.28,0a2.19,2.19,0,0,1,.44.05,1.18,1.18,0,0,1-.44,0l-1.28.05-4.71.08-3.27,0h-1.83c-.3,0-.66,0-.93,0a1.64,1.64,0,0,0-.78.33,1.6,1.6,0,0,0-.49.71,2.6,2.6,0,0,0-.08.95v2.14c0,1.46,0,3,0,4.52l-.26-.26h1.79l14.06.05-.21.21c0-2.95.06-5.4.08-7.2a1.71,1.71,0,0,0-1-1.49A3.35,3.35,0,0,0,254,156.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,183.29a1.32,1.32,0,0,1,0-.33l0-.93c0-.84,0-2-.05-3.52,0-3.06-.06-7.42-.1-12.78l.19.19-36.19.07.26-.26h0v9c0,2.93,0,5.78,0,8.5l-.25-.25,25.93.12,7.52.07,2,0h.53l.19,0a5.27,5.27,0,0,1-.66,0l-2,0-7.47.06-26.09.12h-.25v-.24c0-2.72,0-5.57,0-8.5v-9h0c-.06.05.49-.5.26-.26l36.19.07h.19v.19c0,5.41-.08,9.81-.1,12.9,0,1.48,0,2.64-.05,3.47l0,.9C266.36,183.19,266.35,183.29,266.35,183.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,160.49a61.88,61.88,0,0,1-8,.26,61.78,61.78,0,0,1-7.95-.26,61.78,61.78,0,0,1,7.95-.26A61.88,61.88,0,0,1,255.77,160.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.52,222.26a1.31,1.31,0,0,1-.7-.08,1.86,1.86,0,0,1-1.2-1.59c0-1.74-.07-4.21-.09-7.22v-.21h.21l14.06,0h2v4.78c0,.73,0,1.44,0,2.14a3.29,3.29,0,0,1-.12,1.1,2,2,0,0,1-.66.92,1.92,1.92,0,0,1-1,.42c-.38,0-.66,0-1,0h-1.83l-3.27,0-4.72-.08-1.27,0a2.39,2.39,0,0,1-.45-.05,1.27,1.27,0,0,1,.45,0l1.27-.05,4.72-.08,3.27,0,1.83,0c.3,0,.66,0,.93,0a1.56,1.56,0,0,0,.77-.33,1.54,1.54,0,0,0,.5-.71,2.83,2.83,0,0,0,.08-.95c0-.7,0-1.41,0-2.14,0-1.46,0-3,0-4.52l.26.26H254.8l-14.06,0,.21-.21c0,2.95-.06,5.4-.09,7.2a1.74,1.74,0,0,0,1,1.49C242.27,222.24,242.53,222.22,242.52,222.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.16,195.81a2.4,2.4,0,0,1,0,.33l0,.93c0,.84,0,2,.05,3.52,0,3.06.06,7.42.1,12.78l-.19-.19,36.18-.07c.24-.23-.31.32-.25.26h0v-9.05c0-2.94,0-5.78,0-8.5l.25.25-25.93-.12-7.52-.07-2,0h-.53l-.19,0a5.27,5.27,0,0,1,.66,0l2,0,7.47-.06,26.09-.12h.24v.24c0,2.72,0,5.56,0,8.5,0,1.47,0,3,0,4.47v4.58h0c.05-.06-.5.49-.27.26l-36.18-.07H230v-.19c0-5.41.08-9.81.1-12.9,0-1.48,0-2.64.05-3.47l0-.9A1.51,1.51,0,0,1,230.16,195.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,218.61a61.78,61.78,0,0,1,7.95-.26,61.88,61.88,0,0,1,8,.26,61.88,61.88,0,0,1-8,.26A61.78,61.78,0,0,1,240.74,218.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,222.26a1.35,1.35,0,0,1-.71-.08,1.83,1.83,0,0,1-1.19-1.59c0-1.74-.07-4.21-.1-7.22v-.21h.21l14.06,0h2v.26c0,1.55,0,3.06,0,4.52,0,.73,0,1.44,0,2.14a3.29,3.29,0,0,1-.12,1.1,2,2,0,0,1-.65.92,2,2,0,0,1-1,.42c-.38,0-.66,0-1,0H187.2l-3.27,0-4.72-.08-1.27,0a2.19,2.19,0,0,1-.44-.05,1.18,1.18,0,0,1,.44,0l1.27-.05,4.72-.08,3.27,0,1.83,0c.3,0,.66,0,.93,0a1.64,1.64,0,0,0,.78-.33,1.6,1.6,0,0,0,.49-.71,2.6,2.6,0,0,0,.08-.95c0-.7,0-1.41,0-2.14v-4.52l.26.26h-1.79l-14.06,0,.21-.21c0,2.95-.06,5.4-.08,7.2a1.71,1.71,0,0,0,1,1.49C177.24,222.24,177.5,222.22,177.5,222.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,195.81a1.32,1.32,0,0,1,0,.33c0,.24,0,.55,0,.93,0,.84,0,2,.05,3.52,0,3.06.06,7.42.1,12.78l-.19-.19,36.19-.07-.26.26h0v-9.05c0-2.94,0-5.78,0-8.5l.25.25-25.93-.12-7.52-.07-2,0h-.53l-.19,0a5.27,5.27,0,0,1,.66,0l2,0,7.47-.06,26.09-.12h.25v.24c0,2.72,0,5.56,0,8.5v9.05h0l-.26.26-36.19-.07h-.19v-.19c0-5.41.08-9.81.1-12.9,0-1.48,0-2.64.05-3.47,0-.37,0-.67,0-.9S165.13,195.81,165.13,195.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.71,218.61a61.88,61.88,0,0,1,8-.26,61.78,61.78,0,0,1,8,.26,61.78,61.78,0,0,1-8,.26A61.88,61.88,0,0,1,175.71,218.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.95,
    y: 258,
    width: 1,
    height: 37.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.01,
    y: 257.71,
    width: 1,
    height: 39.6,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.91,
    y: 276.86,
    width: 126.43,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.89,
    y: 257.12,
    width: 1,
    height: 40.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,245.11a1.31,1.31,0,0,1,.7.08,1.83,1.83,0,0,1,1.19,1.59c.05,1.74.07,4.21.1,7.22v.21h-.21l-14.06,0h-2v-4.78c0-.73,0-1.44,0-2.14a3.29,3.29,0,0,1,.12-1.1,2,2,0,0,1,.65-.92,2,2,0,0,1,1-.42c.38,0,.66,0,1,0h1.83l3.27,0,4.72.08,1.27,0a2.39,2.39,0,0,1,.45.05,1.27,1.27,0,0,1-.45,0l-1.27.05-4.72.08-3.27,0-1.83,0c-.3,0-.66,0-.93,0a1.56,1.56,0,0,0-.77.33,1.54,1.54,0,0,0-.5.71,2.83,2.83,0,0,0-.08,1c0,.7,0,1.41,0,2.14,0,1.46,0,3,0,4.52l-.26-.26h1.78l14.06,0-.21.21c0-2.95.06-5.4.09-7.2a1.74,1.74,0,0,0-1-1.49A3.87,3.87,0,0,0,189,245.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.32,271.56a2.4,2.4,0,0,1,0-.33c0-.24,0-.55,0-.93,0-.84,0-2-.05-3.52,0-3.06-.06-7.42-.1-12.78l.19.19-36.19.07.26-.26h0v9.05c0,2.93,0,5.78,0,8.5l-.25-.25,25.93.12,7.52.07,2,0h.53l.19,0a5.27,5.27,0,0,1-.66,0l-2,0-7.47.06-26.09.12h-.24v-.24c0-2.72,0-5.57,0-8.5,0-1.47,0-3,0-4.48V254h0l.26-.26,36.19.07h.19V254c0,5.41-.08,9.81-.1,12.9,0,1.48,0,2.64,0,3.47,0,.37,0,.66,0,.9A1.64,1.64,0,0,1,201.32,271.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,248.76a61.78,61.78,0,0,1-8,.26,61.88,61.88,0,0,1-8-.26,61.88,61.88,0,0,1,8-.26A61.78,61.78,0,0,1,190.74,248.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,245.11a1.35,1.35,0,0,1,.71.08,1.83,1.83,0,0,1,1.19,1.59c.05,1.74.07,4.21.1,7.22v.21h-.21l-14.06,0h-2.05V254c0-1.55,0-3.06,0-4.52,0-.73,0-1.44,0-2.14a2.84,2.84,0,0,1,.12-1.1,2,2,0,0,1,1.67-1.34c.37,0,.66,0,1,0h1.83l3.27,0,4.71.08,1.28,0a2.19,2.19,0,0,1,.44.05,1.18,1.18,0,0,1-.44,0l-1.28.05-4.71.08-3.27,0-1.83,0c-.3,0-.66,0-.93,0a1.64,1.64,0,0,0-.78.33,1.6,1.6,0,0,0-.49.71,2.6,2.6,0,0,0-.08,1v2.14c0,1.46,0,3,0,4.52l-.26-.26h1.79l14.06,0-.21.21c0-2.95.06-5.4.08-7.2a1.71,1.71,0,0,0-1-1.49A3.35,3.35,0,0,0,254,245.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,271.56a1.32,1.32,0,0,1,0-.33l0-.93c0-.84,0-2-.05-3.52,0-3.06-.06-7.42-.1-12.78l.19.19-36.19.07.26-.26h0v9.05c0,2.93,0,5.78,0,8.5l-.25-.25,25.93.12,7.52.07,2,0h.53l.19,0a5.27,5.27,0,0,1-.66,0l-2,0-7.47.06-26.09.12h-.25v-.24c0-2.72,0-5.57,0-8.5V254h0l.26-.26,36.19.07h.19V254c0,5.41-.08,9.81-.1,12.9,0,1.48,0,2.64-.05,3.47l0,.9C266.36,271.46,266.35,271.56,266.35,271.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,248.76a61.88,61.88,0,0,1-8,.26,61.78,61.78,0,0,1-7.95-.26,61.78,61.78,0,0,1,7.95-.26A61.88,61.88,0,0,1,255.77,248.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.52,310.53a1.31,1.31,0,0,1-.7-.08,1.86,1.86,0,0,1-1.2-1.59c0-1.74-.07-4.21-.09-7.22v-.21h.21l14.06-.05h2v4.78c0,.73,0,1.44,0,2.14a3.29,3.29,0,0,1-.12,1.1,2,2,0,0,1-.66.92,1.92,1.92,0,0,1-1,.42c-.38,0-.66,0-1,0h-1.83l-3.27,0-4.72-.08-1.27,0a2.39,2.39,0,0,1-.45-.05,1.27,1.27,0,0,1,.45,0l1.27-.05,4.72-.08,3.27,0,1.83,0c.3,0,.66,0,.93,0a1.56,1.56,0,0,0,.77-.33,1.54,1.54,0,0,0,.5-.71,2.83,2.83,0,0,0,.08-.95c0-.7,0-1.41,0-2.14,0-1.46,0-3,0-4.52l.26.26H254.8l-14.06,0,.21-.21c0,2.95-.06,5.4-.09,7.2a1.74,1.74,0,0,0,1,1.49A5.58,5.58,0,0,0,242.52,310.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.16,284.08a2.4,2.4,0,0,1,0,.33l0,.93c0,.84,0,2,.05,3.52,0,3.06.06,7.42.1,12.78l-.19-.19,36.18-.07c.24-.23-.31.32-.25.26h0v-9.05c0-2.93,0-5.78,0-8.5l.25.25-25.93-.12-7.52-.07-2,0h-.53l-.19,0a5.27,5.27,0,0,1,.66,0l2,0,7.47-.06,26.09-.12h.24v.24c0,2.72,0,5.57,0,8.5,0,1.47,0,3,0,4.47v4.58h0c.05-.06-.5.49-.27.26l-36.18-.07H230v-.19c0-5.41.08-9.81.1-12.9,0-1.48,0-2.64.05-3.47l0-.9A1.64,1.64,0,0,1,230.16,284.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,306.88a61.78,61.78,0,0,1,7.95-.26,61.88,61.88,0,0,1,8,.26,61.88,61.88,0,0,1-8,.26A61.78,61.78,0,0,1,240.74,306.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,310.53a1.35,1.35,0,0,1-.71-.08,1.83,1.83,0,0,1-1.19-1.59c0-1.74-.07-4.21-.1-7.22v-.21h.21l14.06-.05h2v.26c0,1.55,0,3.06,0,4.52,0,.73,0,1.44,0,2.14a3.29,3.29,0,0,1-.12,1.1,2,2,0,0,1-.65.92,2,2,0,0,1-1,.42c-.38,0-.66,0-1,0H187.2l-3.27,0-4.72-.08-1.27,0a2.19,2.19,0,0,1-.44-.05,1.18,1.18,0,0,1,.44,0l1.27-.05,4.72-.08,3.27,0,1.83,0c.3,0,.66,0,.93,0a1.64,1.64,0,0,0,.78-.33,1.6,1.6,0,0,0,.49-.71,2.6,2.6,0,0,0,.08-.95c0-.7,0-1.41,0-2.14v-4.52l.26.26h-1.79l-14.06,0,.21-.21c0,2.95-.06,5.4-.08,7.2a1.71,1.71,0,0,0,1,1.49A4.53,4.53,0,0,0,177.5,310.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,284.08a1.32,1.32,0,0,1,0,.33c0,.24,0,.55,0,.93,0,.84,0,2,.05,3.52,0,3.06.06,7.42.1,12.78l-.19-.19,36.19-.07-.26.26h0v-9.05c0-2.93,0-5.78,0-8.5l.25.25-25.93-.12-7.52-.07-2,0h-.53l-.19,0a5.27,5.27,0,0,1,.66,0l2,0,7.47-.06,26.09-.12h.25v.24c0,2.72,0,5.57,0,8.5v9.05h0l-.26.26-36.19-.07h-.19v-.19c0-5.41.08-9.81.1-12.9,0-1.48,0-2.64.05-3.47,0-.37,0-.66,0-.9S165.13,284.08,165.13,284.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.71,306.88a61.88,61.88,0,0,1,8-.26,61.78,61.78,0,0,1,8,.26,61.78,61.78,0,0,1-8,.26A61.88,61.88,0,0,1,175.71,306.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.14,91.29v15.86a5,5,0,0,0,5,5h8.76V91.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.58,271H123a5.74,5.74,0,0,0,5.74-5.73v-6.4H109.58Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chronometer--inject-204"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.76,
    y: 87.1,
    width: 4.62,
    height: 7.21,
    transform: "translate(61.37 358.07) rotate(-38.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.93,86.6l-7.47,5.89-4.81-6.09a18.15,18.15,0,0,1,7.46-5.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.71,91.51a15.67,15.67,0,0,1-2.74-3,15.17,15.17,0,0,1-2.31-3.34,15.31,15.31,0,0,1,2.74,3A14.76,14.76,0,0,1,542.71,91.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.14,90.38a15.8,15.8,0,0,1-2.71-3.15,20.08,20.08,0,0,1-2.32-3.43c.14-.13,1.39,1.28,2.76,3.1A15.72,15.72,0,0,1,544.14,90.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546,88.89a16.58,16.58,0,0,1-2.72-3.2A19.32,19.32,0,0,1,541,82.2c.14-.12,1.37,1.31,2.75,3.16A16,16,0,0,1,546,88.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.76,87.48a14.92,14.92,0,0,1-2.72-3,14.91,14.91,0,0,1-2.29-3.37,15.16,15.16,0,0,1,2.72,3A15.41,15.41,0,0,1,547.76,87.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.93,
    y: 90.24,
    width: 4.62,
    height: 7.21,
    transform: "translate(275.45 -421.19) rotate(48.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.49,96.48l-6.28-7.14L607,84.21a18.1,18.1,0,0,1,6.28,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.26,90.53a15.14,15.14,0,0,1,2.84-2.89,15.24,15.24,0,0,1,3.21-2.49,15,15,0,0,1-2.84,2.9A15,15,0,0,1,602.26,90.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.46,91.89a16.35,16.35,0,0,1,3-2.86,21.25,21.25,0,0,1,3.31-2.51c.13.15-1.2,1.46-3,2.93A15.52,15.52,0,0,1,603.46,91.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,93.71a16.08,16.08,0,0,1,3.05-2.89,19.53,19.53,0,0,1,3.37-2.49c.12.13-1.24,1.44-3,2.92A16.18,16.18,0,0,1,605.05,93.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.54,95.36a15.21,15.21,0,0,1,2.88-2.88A15.54,15.54,0,0,1,612.66,90a15.21,15.21,0,0,1-2.88,2.88A15.54,15.54,0,0,1,606.54,95.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.07,
    y: 75.92,
    width: 5.47,
    height: 8.53,
    transform: "translate(3.83 -23.87) rotate(2.38)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.54,78.71l-11.25-.47.38-9.18a21.41,21.41,0,0,1,11.25.47Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.05,69.57a12.24,12.24,0,0,1-11.44-.42,19.25,19.25,0,0,0,11.44.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,78.37a13.76,13.76,0,0,1-.12-4,14.32,14.32,0,0,1,.44-3.92,13.76,13.76,0,0,1,.12,4A14.8,14.8,0,0,1,574,78.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.14,78.52a14.68,14.68,0,0,1-.11-4,14.59,14.59,0,0,1,.44-4,13.78,13.78,0,0,1,.11,4A14.13,14.13,0,0,1,576.14,78.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.29,78.57a13.74,13.74,0,0,1-.11-4,14,14,0,0,1,.44-3.94,14.55,14.55,0,0,1,.11,4A14.51,14.51,0,0,1,578.29,78.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.07,78.64a16.7,16.7,0,0,1-.1-4.28,17.12,17.12,0,0,1,.45-4.27,16.32,16.32,0,0,1,.1,4.29A17.09,17.09,0,0,1,580.07,78.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,78.25a17.06,17.06,0,0,1-.09-4.29,16.54,16.54,0,0,1,.45-4.26,16.76,16.76,0,0,1,.1,4.29A16.27,16.27,0,0,1,572,78.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573.42,
    cy: 121.53,
    r: 39.77,
    transform: "translate(-7.17 202.15) rotate(-19.87)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573.44,
    cy: 121.21,
    r: 33.4,
    transform: "translate(223.48 591.37) rotate(-65.27)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.81,122.6s0-.18,0-.54,0-.91,0-1.59q0-.52,0-1.17c0-.43-.1-.89-.15-1.4a25,25,0,0,0-.56-3.47,31.64,31.64,0,0,0-3.33-9,33.35,33.35,0,0,0-8.06-9.77,33,33,0,0,0-13.7-6.76,31.52,31.52,0,0,0-4.17-.66c-.71,0-1.43-.15-2.16-.17l-2.19,0c-.37,0-.74,0-1.11,0l-1.12.12c-.74.09-1.49.15-2.24.27a36.73,36.73,0,0,0-8.87,2.84c-.71.35-1.4.76-2.11,1.14a16.87,16.87,0,0,0-2.05,1.3,36,36,0,0,0-3.89,3,38.62,38.62,0,0,0-3.41,3.7,32.31,32.31,0,0,0-5.11,8.93,32.87,32.87,0,0,0-.87,20.89,32.33,32.33,0,0,0,4.35,9.32,37.32,37.32,0,0,0,3.09,4,36.83,36.83,0,0,0,3.62,3.35,17,17,0,0,0,1.94,1.46c.68.44,1.33.91,2,1.32a35.35,35.35,0,0,0,4.24,2.08,36.12,36.12,0,0,0,4.36,1.48c.74.18,1.48.3,2.22.45l1.1.22c.36.06.73.08,1.1.12l2.19.2c.72.05,1.44,0,2.16,0a30.67,30.67,0,0,0,4.21-.31,33,33,0,0,0,14.22-5.6,33.37,33.37,0,0,0,8.84-9.06,32.11,32.11,0,0,0,4.07-8.69,26.65,26.65,0,0,0,.84-3.41c.09-.5.21-1,.27-1.38s.08-.81.12-1.16c.07-.68.13-1.2.17-1.58s.08-.54.08-.54,0,.18,0,.54-.07.91-.12,1.59q0,.52-.09,1.17c-.06.43-.16.89-.25,1.39a23.81,23.81,0,0,1-.8,3.45,31.46,31.46,0,0,1-4,8.79,33.57,33.57,0,0,1-23.24,14.95,31.67,31.67,0,0,1-4.27.32c-.73,0-1.46,0-2.2,0l-2.22-.2c-.37,0-.75,0-1.12-.12l-1.11-.21c-.74-.16-1.5-.27-2.25-.46a34.94,34.94,0,0,1-4.43-1.49,35.74,35.74,0,0,1-4.31-2.11c-.7-.41-1.36-.88-2.05-1.33a17.47,17.47,0,0,1-2-1.48,38,38,0,0,1-3.69-3.4,38.79,38.79,0,0,1-3.14-4,32.74,32.74,0,0,1-4.43-9.47,33.4,33.4,0,0,1,.89-21.24,32.5,32.5,0,0,1,5.2-9.06,37.61,37.61,0,0,1,3.47-3.76,37.15,37.15,0,0,1,4-3.08,18.24,18.24,0,0,1,2.09-1.31c.72-.39,1.42-.81,2.15-1.16a35,35,0,0,1,4.47-1.74A37.11,37.11,0,0,1,567.84,88c.76-.12,1.52-.18,2.28-.27l1.12-.12c.38,0,.76,0,1.13,0l2.23,0c.74,0,1.46.12,2.19.18a32.28,32.28,0,0,1,4.22.68,33.56,33.56,0,0,1,21.93,16.83,31.45,31.45,0,0,1,3.27,9.1,23.15,23.15,0,0,1,.51,3.49c0,.51.11,1,.13,1.41v1.18c0,.68,0,1.21,0,1.59S606.81,122.6,606.81,122.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,121.88c-3.05-.08-5.52-.33-5.52-.56s2.48-.45,5.52-.5,5.52.19,5.52.55S605,122,602,121.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.25,141.74c-2.11-2.2-3.69-4.11-3.53-4.27s2.07,1.41,4.28,3.52,3.78,4,3.53,4.27S595.36,143.94,593.25,141.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.09,149.74c0-3.05.27-5.52.49-5.52s.48,2.46.57,5.51-.14,5.52-.5,5.52S573,152.78,573.09,149.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.13,141.25c2.18-2.14,4.07-3.74,4.23-3.58s-1.39,2.09-3.47,4.32-4,3.82-4.24,3.57S551,143.38,553.13,141.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.91,121.18c3.05,0,5.52.2,5.52.43s-2.46.51-5.5.63-5.52-.08-5.53-.44S541.86,121.16,544.91,121.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.18,101.13c2.16,2.15,3.78,4,3.62,4.19s-2.1-1.37-4.35-3.43-3.87-3.93-3.62-4.19S551,99,553.18,101.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.16,92.68c0,3-.15,5.52-.38,5.53s-.53-2.45-.68-5.5,0-5.51.38-5.53S573.14,89.64,573.16,92.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.3,100.73c-2.13,2.18-4,3.83-4.15,3.67s1.34-2.12,3.38-4.39,3.89-3.91,4.15-3.67S595.43,98.55,593.3,100.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.48,103.86a113.91,113.91,0,0,1-1.06,14.65,18.41,18.41,0,0,1-1.26,5.15,6.92,6.92,0,0,1-3.64,3.69,4.31,4.31,0,0,1-4.83-1.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "572.82 118.55 585.8 98.63 577.52 121.38 573.73 122.34 572.82 118.55",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "585.8 98.63 575.94 119.12 577.52 121.38 585.8 98.63"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M577.64,122.51a3.91,3.91,0,1,1-3.74-4.07A3.91,3.91,0,0,1,577.64,122.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.64,122.51s0-.35-.19-.94a3.9,3.9,0,0,0-1.35-2.08,3.73,3.73,0,0,0-3.47-.62,3.66,3.66,0,0,0-.28,6.85,3.73,3.73,0,0,0,3.51-.33,3.89,3.89,0,0,0,1.51-2c.2-.58.22-.93.27-.92a2.06,2.06,0,0,1-.06,1,3.89,3.89,0,0,1-1.5,2.22,4.07,4.07,0,0,1-3.92.48,4.15,4.15,0,0,1,.32-7.81,4.1,4.1,0,0,1,3.87.81,3.88,3.88,0,0,1,1.31,2.34A2,2,0,0,1,577.64,122.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.64,122.47a2.91,2.91,0,1,1-2.78-3A2.91,2.91,0,0,1,576.64,122.47Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-204"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253.18,
    cy: 222.26,
    r: 17.86,
    transform: "translate(-20.95 418.09) rotate(-76.82)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 253.18,
    cy: 218.95,
    r: 17.86,
    transform: "translate(-80.67 243.15) rotate(-45)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.92,218a4.93,4.93,0,0,0,2.94-4.57,4.63,4.63,0,1,0-9.25,0,4.93,4.93,0,0,0,2.95,4.61c-7.12,1.07-6.8,8.81-6.8,8.81l16.84.08S262,219.09,254.92,218Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.95,
    cy: 261.08,
    r: 17.86,
    transform: "translate(-85.33 84.95) rotate(-22.09)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 174.68,
    cy: 257.83,
    r: 17.86,
    transform: "translate(-131.15 199.03) rotate(-45)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.42,256.91a5,5,0,0,0,2.94-4.57,4.63,4.63,0,1,0-9.25,0,4.92,4.92,0,0,0,2.94,4.61c-7.12,1.07-6.79,8.81-6.79,8.81l16.83.08S183.48,258,176.42,256.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.35,
    cy: 208.63,
    r: 17.86,
    transform: "translate(-37.29 327.23) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 375.74,
    cy: 205.11,
    r: 17.86,
    transform: "translate(89.21 523.15) rotate(-76.61)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48,204.18a4.92,4.92,0,0,0,2.94-4.56,4.64,4.64,0,1,0-9.25,0,4.92,4.92,0,0,0,2.95,4.6c-7.12,1.08-6.8,8.82-6.8,8.82l16.84.07S384.54,205.25,377.48,204.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.27,
    cy: 131.14,
    r: 17.86,
    transform: "translate(156.88 458.06) rotate(-77.41)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 364.27,
    cy: 128.89,
    r: 17.86,
    transform: "translate(159.07 456.3) rotate(-77.41)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,128A4.93,4.93,0,0,0,369,123.4a4.63,4.63,0,1,0-9.25,0,4.93,4.93,0,0,0,2.95,4.61c-7.12,1.07-6.8,8.81-6.8,8.81l16.84.07S373.07,129,366,128Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-204"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.82,92.05l.94,62.9h39.39a9.11,9.11,0,0,0,9.11-9.11V91.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M143.08,43.34H60.48a7.78,7.78,0,0,0-7.68,7.88V136a7.78,7.78,0,0,0,7.68,7.88h82.6a7.78,7.78,0,0,0,7.68-7.88V51.22A7.78,7.78,0,0,0,143.08,43.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,43.34h97.75a.1.1,0,0,1,.1.1V69.39a5.68,5.68,0,0,1-5.68,5.68H58.72a5.92,5.92,0,0,1-5.92-5.92V43.44A.1.1,0,0,1,52.9,43.34Z",
    transform: "translate(203.56 118.42) rotate(180)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.29,88.06v34a.1.1,0,0,1-.1.11h-7.5a.11.11,0,0,1-.1-.11V94.41a.11.11,0,0,0-.11-.11H81a.11.11,0,0,1-.1-.11V88.06A.1.1,0,0,1,81,88H95.19A.09.09,0,0,1,95.29,88.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,88.06v5a.06.06,0,0,1,0,0l-12.33,29a.12.12,0,0,1-.1.07h-8.14a.11.11,0,0,1-.1-.16L118.3,94.55a.11.11,0,0,0-.09-.15H107.44a.11.11,0,0,0-.11.11v5.35a.11.11,0,0,1-.1.11h-6.64a.11.11,0,0,1-.11-.11V88.06a.1.1,0,0,1,.11-.1h26.47A.1.1,0,0,1,127.17,88.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,61.35c0,.17,6.73.32,15,.32s15-.15,15-.32-6.73-.33-15-.33S88.1,61.17,88.1,61.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.18,43.34a6.56,6.56,0,0,1,1,0,7,7,0,0,1,2.73.89,7.67,7.67,0,0,1,3.19,3.45,7.92,7.92,0,0,1,.75,3c0,1.1,0,2.25,0,3.48,0,9.85,0,24.08.09,41.65,0,8.8,0,18.43,0,28.77v7.88c0,1.34,0,2.67,0,4.05a8.17,8.17,0,0,1-1.27,4,8,8,0,0,1-3.11,2.79,8.23,8.23,0,0,1-4.1.82H134.1l-73.72,0a7.91,7.91,0,0,1-7.53-5.79,9,9,0,0,1-.32-2.52v-7.39q0-9.81,0-19.31c0-12.65,0-24.85,0-36.48q0-8.72,0-17c0-1.38,0-2.75,0-4.1a11,11,0,0,1,.16-2.06h0a8.33,8.33,0,0,1,.67-1.95,8,8,0,0,1,2.6-3,7.83,7.83,0,0,1,3.66-1.34c10.11-.06,19.47,0,28.05,0l40.59.08,11,.06,2.87,0,1,0-1,0-2.87,0-11,.05-40.59.09c-8.56,0-18,0-28,.06a7.33,7.33,0,0,0-5.89,4.14,8.25,8.25,0,0,0-.63,1.83h0a10.69,10.69,0,0,0-.15,2v4.1q0,8.26,0,17c0,11.63,0,23.83,0,36.48q0,9.5,0,19.31v4.91a19.4,19.4,0,0,0,.29,4.85,7.38,7.38,0,0,0,7,5.39l73.72,0h8.39a7.8,7.8,0,0,0,3.89-.76,7.3,7.3,0,0,0,2.92-2.62,7.52,7.52,0,0,0,1.2-3.72c.05-1.33,0-2.7,0-4V124.6c0-10.34,0-20,0-28.77,0-17.57.06-31.8.08-41.65,0-1.22,0-2.39,0-3.47a7.78,7.78,0,0,0-.7-2.91,7.69,7.69,0,0,0-3.1-3.43,7.38,7.38,0,0,0-2.69-.93,6.73,6.73,0,0,0-.72-.07A1.53,1.53,0,0,1,143.18,43.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.27,56.19h0a3.22,3.22,0,0,0,3.18-3.27V36.76a3.22,3.22,0,0,0-3.18-3.27h0a3.23,3.23,0,0,0-3.19,3.27V52.92A3.23,3.23,0,0,0,87.27,56.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.16,56.19a3.76,3.76,0,0,1-1.81-.76,3.13,3.13,0,0,1-1.07-2c0-.9,0-2,0-3.21,0-2.44,0-5.29.07-8.44,0-1.59,0-3.25,0-5a3,3,0,0,1,.8-2.17,2.81,2.81,0,0,1,2.18-.84,2.77,2.77,0,0,1,2.09,1A3.06,3.06,0,0,1,90.15,37c0,1.73,0,3.39,0,5,0,3.15,0,6,.07,8.43,0,.6,0,1.17,0,1.72a8.87,8.87,0,0,1,0,1.48A3.09,3.09,0,0,1,89,55.55a3.92,3.92,0,0,1-1.86.64,1.38,1.38,0,0,0,.53.05,3,3,0,0,0,1.47-.48,3.32,3.32,0,0,0,1.4-2,9,9,0,0,0,.09-1.56c0-.55,0-1.12,0-1.72,0-2.43,0-5.28.06-8.43,0-1.59,0-3.25,0-5a3.73,3.73,0,0,0-.82-2.65,3.36,3.36,0,0,0-2.57-1.21,3.41,3.41,0,0,0-2.62,1,3.6,3.6,0,0,0-1,2.62c0,1.72,0,3.38,0,5,0,3.15,0,6,.07,8.44,0,1.21,0,2.26.08,3.26a3.33,3.33,0,0,0,1.26,2.14,3,3,0,0,0,1.43.58A1.14,1.14,0,0,0,87.16,56.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.17,56.19h0a3.23,3.23,0,0,0,3.19-3.27V36.76a3.23,3.23,0,0,0-3.19-3.27h0A3.23,3.23,0,0,0,114,36.76V52.92A3.23,3.23,0,0,0,117.17,56.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,56.19a3.76,3.76,0,0,1-1.81-.76,3.08,3.08,0,0,1-1.06-2c0-.9,0-2,0-3.21,0-2.44,0-5.29.07-8.44,0-1.59,0-3.25,0-5a2.94,2.94,0,0,1,.81-2.17,3,3,0,0,1,4.27.14,3.05,3.05,0,0,1,.68,2.24c0,1.73,0,3.39,0,5,0,3.15.05,6,.07,8.43,0,.6,0,1.17,0,1.72a8.8,8.8,0,0,1,0,1.48,3.09,3.09,0,0,1-1.2,1.91,3.89,3.89,0,0,1-1.86.64,1.38,1.38,0,0,0,.53.05,2.92,2.92,0,0,0,1.47-.48,3.28,3.28,0,0,0,1.4-2,8.08,8.08,0,0,0,.1-1.56c0-.55,0-1.12,0-1.72,0-2.43,0-5.28.07-8.43,0-1.59,0-3.25,0-5a3.64,3.64,0,0,0-.82-2.65,3.34,3.34,0,0,0-2.57-1.21,3.41,3.41,0,0,0-2.62,1,3.64,3.64,0,0,0-1,2.62c0,1.72,0,3.38,0,5,0,3.15,0,6,.07,8.44,0,1.21,0,2.26.08,3.26a3.33,3.33,0,0,0,1.26,2.14,3.09,3.09,0,0,0,1.43.58A1.14,1.14,0,0,0,117.06,56.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,76.88a5,5,0,0,1,.52,0c.35,0,.86,0,1.54,0a21.25,21.25,0,0,1,5.77,1.28,23.16,23.16,0,0,1,7.84,5.08,22.08,22.08,0,0,1,3.65,4.58,21.2,21.2,0,0,1,2.56,6.06,24.24,24.24,0,0,1-1.33,14.83A32.42,32.42,0,0,1,121,122.22a37.25,37.25,0,0,1-17.59,7.06,35.81,35.81,0,0,1-20-3.21,28.73,28.73,0,0,1-8.41-6.13,23.71,23.71,0,0,1-5.22-8.66,21,21,0,0,1-1-9.7,22.17,22.17,0,0,1,3.35-8.73,35.82,35.82,0,0,1,12.7-11.57,43.53,43.53,0,0,1,26.57-5.09,40.23,40.23,0,0,1,9.1,2.19c.6.23,1.18.4,1.7.64l1.45.67,1.25.57,1,.56,1.34.77c.3.17.44.27.44.27l-.47-.23-1.36-.71c-.29-.17-.63-.34-1-.54l-1.25-.55-1.46-.64c-.52-.23-1.1-.4-1.7-.62a41.08,41.08,0,0,0-9.06-2.09A43.54,43.54,0,0,0,85,81.66a35.38,35.38,0,0,0-12.5,11.45,21.68,21.68,0,0,0-3.27,8.54,20.63,20.63,0,0,0,1,9.47,23.39,23.39,0,0,0,5.12,8.46,28.29,28.29,0,0,0,8.26,6,35.48,35.48,0,0,0,19.76,3.17,36.8,36.8,0,0,0,17.36-7,32,32,0,0,0,10.45-13.28A23.88,23.88,0,0,0,132.51,94a22.5,22.5,0,0,0-6-10.52,23.33,23.33,0,0,0-7.71-5.09A22.47,22.47,0,0,0,113,77l-1.53-.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tabls--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.54,264h97.51c2.62,0,4.74-1.74,4.74-3.89v-45.5c0-2.14-2.12-3.89-4.74-3.89H27.54c-2.62,0-4.74,1.75-4.74,3.89v45.5C22.8,262.26,24.92,264,27.54,264Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.54,264a3.81,3.81,0,0,1-.81,0,5.29,5.29,0,0,1-2.23-.8,3.76,3.76,0,0,1-1.78-3.3c0-1.53,0-3.29,0-5.27,0-7.94,0-19.4-.08-33.56,0-1.77,0-3.58,0-5.43,0-.47,0-.92,0-1.43a3.47,3.47,0,0,1,.5-1.39,4.57,4.57,0,0,1,2.29-1.86,7.25,7.25,0,0,1,2.95-.4H37.5l26.6,0,60.94,0A5.49,5.49,0,0,1,128.9,212a3.85,3.85,0,0,1,1,1.85,10.31,10.31,0,0,1,.1,2.05v8q0,7.89,0,15.55v15c0,1.22,0,2.44,0,3.65v1.82a3.81,3.81,0,0,1-.39,1.86,4.78,4.78,0,0,1-2.89,2.27,6.25,6.25,0,0,1-1.82.25h-1.76l-49.77-.06-33.56-.08-9.12-.05-2.38,0-.8,0,.8,0,2.38,0,9.12,0,33.56-.09,49.77-.05a12.56,12.56,0,0,0,3.44-.24,4.24,4.24,0,0,0,2.59-2,3.21,3.21,0,0,0,.34-1.63v-5.47q0-7.37,0-15V215.87a11.16,11.16,0,0,0-.08-1.94,3.45,3.45,0,0,0-.92-1.6A5,5,0,0,0,125,211L64.1,211l-26.6,0H28.37a6.75,6.75,0,0,0-2.81.37A4.24,4.24,0,0,0,23.47,213a3,3,0,0,0-.45,1.24c-.05.43,0,.92,0,1.38,0,1.85,0,3.66,0,5.43,0,14.16-.06,25.62-.08,33.56,0,2,0,3.74,0,5.27a3.64,3.64,0,0,0,1.69,3.21,5.19,5.19,0,0,0,2.17.84C27.26,264,27.54,264,27.54,264Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,246.22a5.61,5.61,0,0,1-1-.84L155.46,243l-3.7-3.63a7,7,0,0,0-2.5-1.54,8.13,8.13,0,0,0-3.15-.39c-4.51,0-8.59,0-11.54-.08l-3.5-.08a6.53,6.53,0,0,1-1.28-.1,5.67,5.67,0,0,1,1.28-.1l3.5-.09c3,0,7-.07,11.54-.07a8.71,8.71,0,0,1,3.33.43A7.5,7.5,0,0,1,152.1,239l3.62,3.71,2.41,2.54A6.85,6.85,0,0,1,159,246.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92,247.76a1.91,1.91,0,1,1-1.91-1.91A1.92,1.92,0,0,1,161.92,247.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 224.52,
    width: 37.73,
    height: 4.79,
    rx: 1.44,
    transform: "translate(195.79 453.84) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 233.99,
    width: 37.73,
    height: 4.79,
    rx: 1.44,
    transform: "translate(195.79 472.76) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.43,251.54a3.86,3.86,0,1,1-3.1-4.5A3.86,3.86,0,0,1,90.43,251.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,250.64a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,101.76,250.64Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,250.64a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,113,250.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.35,248.27a.51.51,0,0,1-.45-.28.49.49,0,0,1,.05-.53l1.8-2.37a5.87,5.87,0,0,0,1.18-3.61l-.1-6.11a9,9,0,0,1,7-9l0-1.46a1.5,1.5,0,0,1,1.48-1.52h.3a1.59,1.59,0,0,1,1.07.43,1.49,1.49,0,0,1,.45,1l0,1.36a9,9,0,0,1,7.78,8.8l.11,6.35a5.79,5.79,0,0,0,1.49,3.8l1.64,1.83a.5.5,0,0,1,.09.53.49.49,0,0,1-.45.3l-23.42.39ZM49.6,224.43h-.3a.5.5,0,0,0-.5.51l0,1.87a.5.5,0,0,1-.42.5,8,8,0,0,0-6.59,8l.1,6.11a6.79,6.79,0,0,1-1.38,4.23l-1.18,1.56,21.3-.35-.92-1h0A6.86,6.86,0,0,1,58,241.44l-.11-6.35a8,8,0,0,0-7.31-7.87.51.51,0,0,1-.46-.49l0-1.8A.5.5,0,0,0,49.6,224.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.91,222.5h0l0,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.82,251.91a4.13,4.13,0,0,1-2.51-.76,4.6,4.6,0,0,1-1.59-3.05.49.49,0,0,1,.42-.56.5.5,0,0,1,.57.41,3.61,3.61,0,0,0,1.2,2.4,3.19,3.19,0,0,0,1.92.56,3.51,3.51,0,0,0,2.23-.72,2.68,2.68,0,0,0,1-2.36.51.51,0,0,1,.43-.56.5.5,0,0,1,.56.43A3.65,3.65,0,0,1,52.7,251a4.56,4.56,0,0,1-2.86.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,227.5a.51.51,0,0,1-.48-.35.51.51,0,0,1,.33-.63,8.73,8.73,0,0,1,4.17-.16A.49.49,0,0,1,52,227a.5.5,0,0,1-.59.39,7.77,7.77,0,0,0-3.66.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.84,78.84l-.26,0-.74,0-2.86,0-10.5.09-34.65.07h-5a42.6,42.6,0,0,0-4.83.14,15.32,15.32,0,0,0-8.14,3.63,15.25,15.25,0,0,0-4.54,6.72,19.73,19.73,0,0,0-.86,7.09c0,4.4-.06,8-.08,10.5,0,1.21,0,2.16-.05,2.86,0,.3,0,.54,0,.74a.13.13,0,1,1-.06,0c0-.2,0-.44,0-.74,0-.7,0-1.65-.05-2.86,0-2.52-.05-6.1-.08-10.5a19.53,19.53,0,0,1,.81-7.23,16.18,16.18,0,0,1,1.78-3.68,15.93,15.93,0,0,1,11.25-7,41.91,41.91,0,0,1,4.89-.15h5l34.65.08,10.5.08,2.86.05.74,0A.76.76,0,0,1,436.84,78.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.34,
    y: 55.86,
    width: 110.53,
    height: 50.31,
    rx: 3.96,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.91,106.16s.28,0,.81-.1a4.08,4.08,0,0,0,2-1.16,4,4,0,0,0,.87-1.48,6,6,0,0,0,.18-2.08c0-1.53,0-3.3,0-5.29,0-8,0-19.51-.08-33.74,0-.89,0-1.8,0-2.69a3.76,3.76,0,0,0-3.36-3.54c-.91,0-1.91,0-2.87,0H500.32l-26.74,0-61.27,0a3.71,3.71,0,0,0-3.17,1.78,3.66,3.66,0,0,0-.53,1.79V85.33c0,5.12,0,10.16,0,15.09v1.84a3.81,3.81,0,0,0,.42,1.65,3.69,3.69,0,0,0,2.65,2,12.52,12.52,0,0,0,1.75.06h5.35l50,.06,33.74.08,9.18,0,2.38,0,.81,0s-.27,0-.81,0l-2.38,0-9.18,0-33.74.08-50,.05h-5.35a11.58,11.58,0,0,1-1.84-.07,4.17,4.17,0,0,1-3-2.2,4.25,4.25,0,0,1-.47-1.88V85.33q0-7.69,0-15.64v-10a4.12,4.12,0,0,1,.61-2,4.21,4.21,0,0,1,3.61-2l61.27,0,26.74,0,12.12,0c1,0,1.92,0,2.91,0a4.22,4.22,0,0,1,2.59,1.3,4.06,4.06,0,0,1,1.11,2.62c0,.93,0,1.81,0,2.71,0,14.23-.06,25.76-.08,33.74,0,2,0,3.76,0,5.29a6,6,0,0,1-.22,2.12,4,4,0,0,1-.92,1.51,4,4,0,0,1-2.08,1.14A3,3,0,0,1,514.91,106.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.84,93.87A11.85,11.85,0,1,1,441.68,82,11.86,11.86,0,0,1,429.84,93.87Zm0-22.69A10.85,10.85,0,1,0,440.68,82,10.86,10.86,0,0,0,429.84,71.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,83.26h-7.07a.5.5,0,0,1-.5-.5v-7.4a.5.5,0,0,1,1,0v6.9h6.57a.5.5,0,1,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.3,
    y: 72.12,
    width: 57.48,
    height: 6.48,
    rx: 1.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.86,
    y: 83.68,
    width: 25.94,
    height: 6.48,
    rx: 1.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.1,86.92a4.17,4.17,0,1,1-4.17-4.16A4.17,4.17,0,0,1,486.1,86.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.8,86.92a4.17,4.17,0,1,1-4.17-4.16A4.17,4.17,0,0,1,497.8,86.92Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-204"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.08,
    y: 444.38,
    width: 154.57,
    height: 21.44,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.08,
    y: 447.06,
    width: 152.05,
    height: 16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 308.61,
    y: 444.38,
    width: 30.03,
    height: 21.44
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.13,450.56h-1.55l-4.43,0-16.31,0-53.81,0-53.82,0-16.31,0-4.44,0h0l4.44,0,16.31,0,53.82,0,53.81,0,16.31,0,4.43,0h1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.13,454.84h-1.55l-4.43,0-16.31,0L260,455l-53.82,0-16.31,0-4.44,0h-1.54l.39,0h1.15l4.44,0,16.31,0,53.82,0,53.81,0,16.31,0,4.43,0h1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7,465.47c-.05,0-.1-4.67-.1-10.43s0-10.42.1-10.42.1,4.67.1,10.42S308.75,465.47,308.7,465.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.63,
    y: 424.55,
    width: 106.89,
    height: 19.84,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.74,
    y: 424.66,
    width: 29.09,
    height: 19.61,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.48,
    y: 427.35,
    width: 26.35,
    height: 14.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 296.74,
    y: 424.66,
    width: 29.09,
    height: 19.61
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.92,440s0-.19,0-.55v-1.59c0-1.4,0-3.47,0-6.15l0,0-72.72.07h0l.1-.11V440l-.1-.11,51.64.05,15.45,0,4.18,0h-4.14l-15.42,0-51.71,0h-.09v-8.52h.1l72.72.07h0v.05c0,2.69,0,4.77,0,6.18,0,.69,0,1.22,0,1.58S288.92,440,288.92,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.78,444.25s-.1-4.44-.1-9.92.05-9.93.1-9.93.1,4.44.1,9.93S296.83,444.25,296.78,444.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.05,
    y: 401.39,
    width: 106.89,
    height: 15.52,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34,413.86a1.62,1.62,0,0,1,0-.18c0-.14,0-.3,0-.5,0-.45,0-1.07,0-1.84,0-1.58,0-3.78-.05-6.36l.09.1h-5.06s.18-.21.1-.11h0v2.43c0,.8,0,1.58,0,2.33,0,1.49,0,2.87,0,4.1l-.08-.09,3.66,0,1,0a1.53,1.53,0,0,1,.37,0l-.34,0-1,0-3.71.05h-.08v-.09c0-1.23,0-2.61,0-4.1,0-.75,0-1.53,0-2.33V405h0c-.08.1.12-.14.1-.11h5.15V405c0,2.61,0,4.83,0,6.43,0,.76,0,1.37,0,1.82,0,.19,0,.34,0,.47A.92.92,0,0,1,286.34,413.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.45,
    y: 403.82,
    width: 16.49,
    height: 10.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 291.28,
    y: 401.39,
    width: 18.66,
    height: 15.52
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.2,416.82c-.05,0-.1-3.42-.1-7.65s0-7.65.1-7.65.1,3.43.1,7.65S291.26,416.82,291.2,416.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.07,406.31c0,.06-3.75.11-8.37.11s-8.37-.05-8.37-.11,3.75-.12,8.37-.12S310.07,406.25,310.07,406.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.07,409.07c0,.06-3.75.11-8.37.11s-8.37-.05-8.37-.11,3.75-.11,8.37-.11S310.07,409,310.07,409.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.07,411.87c0,.07-3.75.12-8.37.12s-8.37-.05-8.37-.12,3.75-.11,8.37-.11S310.07,411.81,310.07,411.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.39,
    y: 416.92,
    width: 106.89,
    height: 7.66,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.39,
    y: 417.88,
    width: 23.9,
    height: 5.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 303.04,
    y: 416.92,
    width: 25.25,
    height: 7.66
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M303,424.58a31.46,31.46,0,0,1-.09-3.69,35.79,35.79,0,0,1,.1-3.69,31.59,31.59,0,0,1,.09,3.69A35.79,35.79,0,0,1,303,424.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.07,
    y: 419.87,
    width: 64.38,
    height: 1.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.44,424.52c0,.06-17.72.11-39.56.11s-39.57-.05-39.57-.11,17.71-.12,39.57-.12S300.44,424.45,300.44,424.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,424.55c0,.06-17.71.12-39.56.12s-39.57-.06-39.57-.12,17.71-.11,39.57-.11S303.3,424.49,303.3,424.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.28,416.86c0,.06-23.3.11-52,.11s-52.06-.05-52.06-.11,23.31-.11,52.06-.11S328.28,416.8,328.28,416.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690.53,406.5,552.06,392.77a6.12,6.12,0,0,1-5.48-6.69l20-201.64a6.12,6.12,0,0,1,6.69-5.49l138.47,13.73a6.12,6.12,0,0,1,5.48,6.69L697.22,401A6.12,6.12,0,0,1,690.53,406.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.53,406.5H691a6.12,6.12,0,0,0,1.38-.13,6.12,6.12,0,0,0,4.18-3.21,5.73,5.73,0,0,0,.57-1.81c.1-.66.15-1.37.23-2.1.14-1.48.3-3.09.47-4.84.34-3.5.74-7.54,1.18-12.09,1.8-18.18,4.39-44.48,7.59-77,1.61-16.25,3.37-34,5.25-53.16q1.42-14.34,2.93-29.62.76-7.63,1.54-15.49c.25-2.61.51-5.25.77-7.9a6,6,0,0,0-1-3.72A6.06,6.06,0,0,0,713,193.1a8.47,8.47,0,0,0-2-.35l-2-.2-4.06-.4-8.21-.81-16.69-1.65-34.42-3.41-72.39-7.18a6.07,6.07,0,0,0-4.27,1.23,6,6,0,0,0-2.23,3.83c-.33,3.06-.62,6.15-.93,9.21q-.92,9.18-1.81,18.24-1.8,18.12-3.54,35.67c-2.32,23.39-4.56,46-6.69,67.44s-4.17,41.91-6.07,61c-.23,2.39-.47,4.76-.7,7.11-.11,1.17-.25,2.34-.34,3.5a6,6,0,0,0,.77,3.29,6.11,6.11,0,0,0,2.39,2.34,6.35,6.35,0,0,0,1.58.57c.55.1,1.12.15,1.68.21l6.72.66L585.33,396l77,7.68,20.93,2.1,5.44.56c1.22.12,1.85.2,1.85.2l-1.86-.17-5.44-.53-20.93-2.05-77-7.58-25.51-2.52-6.72-.67c-.56-.05-1.13-.1-1.71-.2a6.87,6.87,0,0,1-1.64-.6,6.32,6.32,0,0,1-2.49-2.43,6.12,6.12,0,0,1-.79-3.41c.09-1.18.22-2.34.33-3.52.23-2.34.47-4.71.7-7.1,1.89-19.11,3.91-39.53,6-61s4.36-44.05,6.68-67.43q1.74-17.55,3.53-35.68.9-9.06,1.81-18.24c.31-3.07.59-6.13.93-9.22a6.25,6.25,0,0,1,6.82-5.31L645.68,186l34.42,3.42,16.69,1.65,8.2.82,4.07.4,2,.2a8.75,8.75,0,0,1,2,.36,6.32,6.32,0,0,1,3.22,2.46,6.25,6.25,0,0,1,1,3.89c-.26,2.65-.51,5.29-.77,7.91q-.78,7.85-1.54,15.49-1.51,15.27-2.94,29.61c-1.91,19.11-3.68,36.91-5.29,53.16-3.25,32.5-5.87,58.81-7.68,77-.46,4.54-.86,8.58-1.21,12.07-.18,1.75-.34,3.37-.49,4.84-.08.74-.13,1.45-.23,2.12a6,6,0,0,1-.59,1.81,6.19,6.19,0,0,1-2.11,2.35,6.26,6.26,0,0,1-2.11.87,6.75,6.75,0,0,1-1.39.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "560.79 388.27 687.18 400.11 691.04 375.84 688.63 360.74 561.65 367.88 560.79 388.27"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M690.53,406.5H691a6.12,6.12,0,0,0,1.38-.13,6.12,6.12,0,0,0,4.18-3.21,5.73,5.73,0,0,0,.57-1.81c.1-.66.15-1.37.23-2.1.14-1.48.3-3.09.47-4.84.34-3.5.74-7.54,1.18-12.09,1.8-18.18,4.39-44.48,7.59-77,1.61-16.25,3.37-34,5.25-53.16q1.42-14.34,2.93-29.62.76-7.63,1.54-15.49c.25-2.61.51-5.25.77-7.9a6,6,0,0,0-1-3.72A6.06,6.06,0,0,0,713,193.1a8.47,8.47,0,0,0-2-.35l-2-.2-4.06-.4-8.21-.81-16.69-1.65-34.42-3.41-72.39-7.18a6.07,6.07,0,0,0-4.27,1.23,6,6,0,0,0-2.23,3.83c-.33,3.06-.62,6.15-.93,9.21q-.92,9.18-1.81,18.24-1.8,18.12-3.54,35.67c-2.32,23.39-4.56,46-6.69,67.44s-4.17,41.91-6.07,61c-.23,2.39-.47,4.76-.7,7.11-.11,1.17-.25,2.34-.34,3.5a6,6,0,0,0,.77,3.29,6.11,6.11,0,0,0,2.39,2.34,6.35,6.35,0,0,0,1.58.57c.55.1,1.12.15,1.68.21l6.72.66L585.33,396l77,7.68,20.93,2.1,5.44.56c1.22.12,1.85.2,1.85.2l-1.86-.17-5.44-.53-20.93-2.05-77-7.58-25.51-2.52-6.72-.67c-.56-.05-1.13-.1-1.71-.2a6.87,6.87,0,0,1-1.64-.6,6.32,6.32,0,0,1-2.49-2.43,6.12,6.12,0,0,1-.79-3.41c.09-1.18.22-2.34.33-3.52.23-2.34.47-4.71.7-7.1,1.89-19.11,3.91-39.53,6-61s4.36-44.05,6.68-67.43q1.74-17.55,3.53-35.68.9-9.06,1.81-18.24c.31-3.07.59-6.13.93-9.22a6.25,6.25,0,0,1,6.82-5.31L645.68,186l34.42,3.42,16.69,1.65,8.2.82,4.07.4,2,.2a8.75,8.75,0,0,1,2,.36,6.32,6.32,0,0,1,3.22,2.46,6.25,6.25,0,0,1,1,3.89c-.26,2.65-.51,5.29-.77,7.91q-.78,7.85-1.54,15.49-1.51,15.27-2.94,29.61c-1.91,19.11-3.68,36.91-5.29,53.16-3.25,32.5-5.87,58.81-7.68,77-.46,4.54-.86,8.58-1.21,12.07-.18,1.75-.34,3.37-.49,4.84-.08.74-.13,1.45-.23,2.12a6,6,0,0,1-.59,1.81,6.19,6.19,0,0,1-2.11,2.35,6.26,6.26,0,0,1-2.11.87,6.75,6.75,0,0,1-1.39.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "560.79 388.27 687.18 400.11 691.04 375.84 688.63 360.74 561.65 367.88 560.79 388.27"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 533.94,
    y: 223.96,
    width: 196.06,
    height: 136.05,
    transform: "translate(279.06 892.06) rotate(-84.34)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690,396.25c.11-1.13,7.88-80,19.22-195.12l.11.14L574,187.86h0l.15-.13c-7.27,73.27-14,141-19.37,195.1l-.1-.12L690,396.25l-135.4-13.32h-.11v-.11c5.36-54.14,12.06-121.83,19.32-195.1v-.14H574L709.35,201h.12v.13C698,316.29,690.1,395.12,690,396.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.19,
    y: 214.18,
    width: 68.24,
    height: 6.3,
    rx: 2.9,
    transform: "translate(24.58 -62.31) rotate(5.66)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.21,
    y: 239.1,
    width: 78.32,
    height: 5.33,
    rx: 2.45,
    transform: "translate(27.03 -63.09) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.37,
    y: 246.63,
    width: 40.15,
    height: 5.33,
    rx: 2.45,
    transform: "translate(27.68 -61.09) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.12,
    y: 270.29,
    width: 78.32,
    height: 5.33,
    rx: 2.45,
    transform: "matrix(1, 0.1, -0.1, 1, 30.09, -62.63)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.28,
    y: 277.83,
    width: 40.15,
    height: 5.33,
    rx: 2.45,
    transform: "translate(30.74 -60.63) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.02,
    y: 301.48,
    width: 78.32,
    height: 5.33,
    rx: 2.45,
    transform: "translate(33.16 -62.17) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.18,
    y: 309.02,
    width: 40.15,
    height: 5.33,
    rx: 2.45,
    transform: "translate(33.8 -60.17) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.93,
    y: 332.67,
    width: 78.32,
    height: 5.33,
    rx: 2.45,
    transform: "translate(36.22 -61.72) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.09,
    y: 340.21,
    width: 40.15,
    height: 5.33,
    rx: 2.45,
    transform: "translate(36.87 -59.71) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.62,
    y: 359.75,
    width: 78.32,
    height: 5.33,
    rx: 2.45,
    transform: "translate(38.87 -61.16) rotate(5.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.79,180.77h63.07a3.35,3.35,0,0,1,3.35,3.35V201a0,0,0,0,1,0,0H610.44a0,0,0,0,1,0,0V184.12A3.35,3.35,0,0,1,613.79,180.77Z",
    transform: "translate(21.98 -62.74) rotate(5.66)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "655.91 174.12 638.24 172.37 638.8 187.72 652.11 189.04 655.91 174.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.57,183.82c0,.08-13.55-1.2-30.26-2.85s-30.25-3.07-30.24-3.15,13.56,1.2,30.27,2.86S676.58,183.74,676.57,183.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.49,194.42c-.08,0,.14-2.86.49-6.38s.69-6.35.77-6.34-.13,2.86-.48,6.37S611.57,194.43,611.49,194.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.26,199.42a57.06,57.06,0,0,1,.43-5.79c.32-3.19.64-5.77.72-5.76a57.06,57.06,0,0,1-.43,5.79C677.66,196.85,677.34,199.43,677.26,199.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.65,201.77c0,.08-13.92-1.24-31.07-2.94s-31-3.14-31-3.22,13.92,1.23,31.07,2.93S673.66,201.69,673.65,201.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "680.46 190.03 682.49 198.83 682.08 203 678.84 202.68 680.46 190.03"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 583.3,
    y: 230.77,
    width: 17.78,
    height: 17.78,
    rx: 3.6,
    transform: "translate(26.54 -57.26) rotate(5.66)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "586.05 239.3 588.01 237.7 591.15 241.09 597.46 235.9 598.93 237.85 590.55 244.5 586.05 239.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.52,
    y: 262.08,
    width: 17.78,
    height: 17.78,
    rx: 3.6,
    transform: "translate(29.61 -56.73) rotate(5.66)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.28 270.61 584.24 269.01 587.37 272.4 593.68 267.21 595.16 269.16 586.77 275.81 582.28 270.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.18,
    y: 293.11,
    width: 17.78,
    height: 17.78,
    rx: 3.6,
    transform: "translate(32.65 -56.25) rotate(5.66)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.93 301.65 580.89 300.04 584.02 303.44 590.33 298.24 591.81 300.19 583.43 306.85 578.93 301.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.66,342.18s.23,0,.66-.05a3.68,3.68,0,0,0,1.7-.66,3.51,3.51,0,0,0,1.42-2.42c.11-1.18.23-2.5.36-3.95s.28-3.07.44-4.78l.12-1.31a5.84,5.84,0,0,0,0-1.31,3.35,3.35,0,0,0-1.26-2.25,3.42,3.42,0,0,0-1.22-.61,10.55,10.55,0,0,0-1.46-.19l-3.09-.3-6.51-.64a3.36,3.36,0,0,0-2.78,1.05,3.46,3.46,0,0,0-.75,1.3,8.94,8.94,0,0,0-.22,1.53c-.21,2.1-.42,4.12-.61,6.06q-.15,1.44-.3,2.82a8.72,8.72,0,0,0-.08,1.32,3.26,3.26,0,0,0,.3,1.19,3.4,3.4,0,0,0,1.61,1.65,6.41,6.41,0,0,0,2.18.43l6.91.77,1.88.23a2.88,2.88,0,0,1,.65.12,3.31,3.31,0,0,1-.66,0l-1.89-.14-6.93-.6-1.12-.11a3.92,3.92,0,0,1-1.19-.33,3.74,3.74,0,0,1-1.83-1.83,3.8,3.8,0,0,1-.36-1.34,9.17,9.17,0,0,1,.08-1.4q.13-1.37.27-2.82.29-2.91.58-6.07a9.77,9.77,0,0,1,.24-1.62,4,4,0,0,1,.86-1.5,3.87,3.87,0,0,1,3.21-1.22l6.51.65,3.09.32a10.22,10.22,0,0,1,1.53.21,3.77,3.77,0,0,1,1.4.7,3.87,3.87,0,0,1,1.42,2.58,7.09,7.09,0,0,1-.06,1.4c0,.45-.1.88-.14,1.31-.18,1.71-.35,3.31-.51,4.78s-.3,2.77-.43,3.94a3.64,3.64,0,0,1-1.59,2.55,3.58,3.58,0,0,1-1.81.61A2,2,0,0,1,586.66,342.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.75,371.57s.23,0,.65-.05a3.53,3.53,0,0,0,3.13-3.08c.1-1.17.22-2.49.35-3.95s.29-3.06.45-4.78l.12-1.31a6.44,6.44,0,0,0,0-1.31,3.39,3.39,0,0,0-1.27-2.25,3.34,3.34,0,0,0-1.22-.61,11.88,11.88,0,0,0-1.45-.19l-3.1-.3-6.5-.64a3.34,3.34,0,0,0-2.78,1.06,3.18,3.18,0,0,0-.75,1.29,8.05,8.05,0,0,0-.22,1.53c-.22,2.1-.42,4.13-.62,6.06-.1,1-.2,1.91-.29,2.82a8.79,8.79,0,0,0-.09,1.32,3.42,3.42,0,0,0,.3,1.19,3.38,3.38,0,0,0,1.62,1.65,6.18,6.18,0,0,0,2.18.43l6.91.77,1.88.24a4.9,4.9,0,0,1,.65.11,2.55,2.55,0,0,1-.66,0l-1.89-.14-6.93-.6-1.12-.11a3.58,3.58,0,0,1-1.19-.33,3.79,3.79,0,0,1-2.19-3.17,9.05,9.05,0,0,1,.07-1.39c.09-.92.18-1.86.27-2.83.19-1.93.39-4,.59-6.06a8.13,8.13,0,0,1,.24-1.63,3.77,3.77,0,0,1,.86-1.5,3.89,3.89,0,0,1,3.21-1.22l6.5.65,3.1.32a10.58,10.58,0,0,1,1.53.21,3.88,3.88,0,0,1,1.39.7A3.83,3.83,0,0,1,589,357a6.37,6.37,0,0,1-.06,1.4c0,.45-.09.88-.13,1.31-.19,1.72-.36,3.32-.51,4.78s-.31,2.77-.44,4a3.64,3.64,0,0,1-1.59,2.54,3.55,3.55,0,0,1-1.81.61A1.87,1.87,0,0,1,583.75,371.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.37,382.92c6.75-3.48,14.7-3.94,22.19-2.7,4,.67,8.23,1.87,11,4.9s3.26,8.35.11,10.94c-1.87,1.55-4.48,1.79-6.91,1.76-5.87-.07-12.38-1.1-17.07,2.43-2.67,2-4.45,5.36-7.65,6.35s-6.66-.88-8.32-3.7-1.71-6.35-.94-9.53A14.58,14.58,0,0,1,116.37,382.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,369.89c4.13,5.89,12.15,3.94,15.87.34s5.29-8.81,6.73-13.79c3.27-11.36,6.56-23.28,4.13-34.86a19.43,19.43,0,0,0-4.45-9.48c-2.43-2.56-6.17-4.09-9.59-3.19-4,1.07-6.56,5-8.38,8.8A83.13,83.13,0,0,0,97,353.38c0,5.74.66,11.77,3.9,16.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.18,389.11c4-4.79,4.79-11.76,3-17.75s-5.84-11.09-10.51-15.25A56.77,56.77,0,0,0,64.84,345a20.06,20.06,0,0,0-8.46-1.43,8.89,8.89,0,0,0-7.11,4.29c-2,3.78-.08,8.36,2,12.1a143,143,0,0,0,12.36,18.83c3.71,4.78,8,9.49,13.6,11.65s11.51,1.91,14.51-2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.62,442a12.8,12.8,0,0,0,.37-2.68c.19-1.95.43-4.4.71-7.32a104.43,104.43,0,0,1,1.65-10.72,81.66,81.66,0,0,1,3.9-12.66,46.56,46.56,0,0,1,6.46-11.45,24.18,24.18,0,0,1,8.17-6.8,22.8,22.8,0,0,1,6.89-2.14,12.54,12.54,0,0,0,2.66-.39,13.79,13.79,0,0,0-2.71,0,21,21,0,0,0-7.18,1.87,24,24,0,0,0-8.62,6.85,45.85,45.85,0,0,0-6.7,11.69,78.26,78.26,0,0,0-3.87,12.86,90.36,90.36,0,0,0-1.42,10.86c-.24,3.11-.32,5.62-.37,7.36A12,12,0,0,0,100.62,442Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.12,453.21a5.52,5.52,0,0,0,.08-1.25c0-.93,0-2.11,0-3.55,0-3.09,0-7.55.15-13.06.28-11,1.23-22.9,3.06-39.63,1.74-15.73,4.07-34,6.53-45.94.52-2.71,1.06-5.15,1.56-7.28s.88-4,1.27-5.47.62-2.55.83-3.46a5.05,5.05,0,0,0,.22-1.23,5.24,5.24,0,0,0-.43,1.17l-1,3.41c-.46,1.47-.93,3.3-1.47,5.43s-1.14,4.56-1.72,7.26a404.07,404.07,0,0,0-6.86,42.64c-1.84,16.76-2.66,32-2.74,43.08-.06,5.53,0,10,.2,13.09.08,1.44.16,2.62.21,3.55A5,5,0,0,0,101.12,453.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.64,429.93a20.83,20.83,0,0,0,0-3.34c-.13-2.14-.42-5.24-1-9a118.24,118.24,0,0,0-2.94-13.18,108,108,0,0,0-5.51-15.59c-4.57-10.84-10.78-19.71-16.18-25.2A40.94,40.94,0,0,0,72.15,360c-.58-.49-1.1-1-1.63-1.38l-1.47-1a21.21,21.21,0,0,0-2.81-1.8c-.16.21,4,2.65,9.21,8.22a87.58,87.58,0,0,1,15.78,25.1,123.09,123.09,0,0,1,5.54,15.45,134.08,134.08,0,0,1,3.13,13.05c.69,3.76,1.09,6.83,1.33,9A21.52,21.52,0,0,0,101.64,429.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.17 426.64 78.06 465.82 124.03 465.82 126.89 426.64 74.17 426.64",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.61,
    y: 418.57,
    width: 64.92,
    height: 14.98,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,433.3c0,.17-12.23.31-27.32.31s-27.33-.14-27.33-.31S86,433,101.06,433,128.38,433.14,128.38,433.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.55,324c3.93.21,6.88-4.35,6.11-8.21s-4.15-6.72-7.79-8.23-7.6-2-11.41-2.94a43.16,43.16,0,0,1-26.89-21,73.41,73.41,0,0,1-5-12.24c-5.35-22.56-12.77-54.81-14.58-67.37-4.68-32.45-13-68.07-59.32-64.75,0,0-30.82,5.8-42.65,27.91-10.4,19.44-4.4,78.05-5.77,120.28l10.1,6.09,1.56.09a40.28,40.28,0,0,0,5.58,12.11c9.23,13.17,21.79,23.74,35.41,32.29,27.53,17.27,60.47,26.7,92.8,23.46,6.83-.69,13.75-2,19.72-5.36s10.91-9.17,11.81-16S601.17,325.87,594.55,324Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.53,151.4l2.9-2.76,31.34,12.63a8.75,8.75,0,0,1,8.27,8.47l-.28,102.12c0,6.93-1.35,12.93-5.53,18.45l-4.4,5.81c-10,13.25-30.68,12.16-38.63-2.44a11.15,11.15,0,0,1-1.11-2.64,19.9,19.9,0,0,1-.47-2.29c-.93-8.21-1-15.34-1-15.34-.56-9-.74-12.72-.75-12.63s-19.19-2.21-24.38-26.85c-2.58-12.26-2.1-29.12-1.37-45.71C435.14,165.25,451.07,151.38,469.53,151.4Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.09,205a3.21,3.21,0,0,0,3.24,3.06,3.06,3.06,0,0,0,3.14-3,3.2,3.2,0,0,0-3.23-3.06A3.06,3.06,0,0,0,471.09,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.49,205a3.2,3.2,0,0,0,3.23,3.06,3,3,0,0,0,3.14-3,3.19,3.19,0,0,0-3.22-3.06A3.05,3.05,0,0,0,440.49,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.42,194.78c.41.4,2.74-1.51,6.16-1.67s6,1.42,6.38,1c.18-.19-.27-.92-1.4-1.66a8.81,8.81,0,0,0-5.13-1.31,8.49,8.49,0,0,0-4.89,1.85C437.53,193.83,437.21,194.6,437.42,194.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.2,195.13c.46.36,2.58-1.78,6-2.29s6.14.79,6.44.32c.16-.21-.35-.89-1.56-1.51a8.73,8.73,0,0,0-5.24-.77,8.46,8.46,0,0,0-4.67,2.34C472.23,194.18,472,195,472.2,195.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.23,220.09c0-.2-2.14-.46-5.62-.73-.88,0-1.72-.17-1.89-.76a4.47,4.47,0,0,1,.45-2.63q1.08-3.24,2.25-6.79c3.12-9.67,5.33-17.61,4.94-17.73s-3.23,7.62-6.35,17.29c-.75,2.38-1.46,4.65-2.14,6.83a5,5,0,0,0-.29,3.45,2.19,2.19,0,0,0,1.51,1.21,5.43,5.43,0,0,0,1.49.13C458.07,220.38,460.22,220.28,460.23,220.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.89,260.77a63.3,63.3,0,0,0,32.83-10.54s-7.51,17.62-32.48,16.54Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.09,228.28a6.17,6.17,0,0,1,5.42-2.57,5.59,5.59,0,0,1,4,1.89,3.57,3.57,0,0,1,.48,4.07c-.86,1.35-2.78,1.75-4.44,1.36a12.84,12.84,0,0,1-4.51-2.39,3.81,3.81,0,0,1-1-1,1.14,1.14,0,0,1-.06-1.27",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.44,222c-.56,0-.38,3.71-3.44,6.51s-7,2.59-7,3.11c0,.24.92.68,2.59.64a9.26,9.26,0,0,0,5.89-2.38,8.09,8.09,0,0,0,2.64-5.46C471.15,222.82,470.69,221.92,470.44,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.92,181.77c.48.87,3.8-.08,7.85-.21s7.44.46,7.84-.45c.18-.43-.51-1.22-1.95-1.91a13.64,13.64,0,0,0-12,.5C469.34,180.52,468.71,181.36,468.92,181.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,180.05c.64.75,3-.18,5.8-.36s5.27.26,5.78-.58c.23-.41-.19-1.17-1.28-1.85a8.4,8.4,0,0,0-9.33.76C437.91,178.87,437.62,179.68,437.91,180.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.41,213.32s-17.56,5.47-27.49-37.87c-3.4-14.81-17.14-26.81-17.14-26.81l5.57-1.68s34.63,9.75,35.21,10.19,8.74,17.91,8.74,17.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.08,211.71c-.08-1.85,1.83-6.32,3.65-6.7,4.84-1,13.65-1,14.35,11.33,1,16.94-16.23,14.41-16.29,13.92S507.39,218.1,507.08,211.71Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.6,223.56c.07-.06.31.19.82.39a3,3,0,0,0,2.2-.08c1.76-.76,3.1-3.69,3-6.74a9.6,9.6,0,0,0-1.07-4.18,3.39,3.39,0,0,0-2.34-2.14,1.52,1.52,0,0,0-1.7.91c-.2.49-.07.82-.16.85s-.38-.26-.28-1a1.87,1.87,0,0,1,.6-1.1,2.27,2.27,0,0,1,1.61-.52,4.15,4.15,0,0,1,3.23,2.45,10,10,0,0,1,1.29,4.66c.09,3.42-1.48,6.71-3.89,7.56a3.19,3.19,0,0,1-2.72-.3C513.65,224,513.54,223.59,513.6,223.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.72,275.69a41.72,41.72,0,0,1-.38-5.91A93,93,0,0,1,527,253.7c.61-3.36,1.27-7,2-11A106.31,106.31,0,0,0,530.48,230a52.2,52.2,0,0,0-1-14,35.1,35.1,0,0,0-2.38-7,33.87,33.87,0,0,0-4-6.51,78.38,78.38,0,0,0-10.66-10.73c-3.71-3.22-7.26-6.37-10.42-9.6a132.34,132.34,0,0,1-15.23-18.53,127.37,127.37,0,0,1-8.25-13.9c-.86-1.7-1.51-3-1.92-4l-.47-1-.15-.36a1.57,1.57,0,0,1,.19.34l.52,1c.44.91,1.1,2.23,2,3.91A137.66,137.66,0,0,0,487,163.43a133.9,133.9,0,0,0,15.26,18.4c3.16,3.22,6.7,6.35,10.42,9.56a78.29,78.29,0,0,1,10.73,10.8,33.91,33.91,0,0,1,4.06,6.59,35.66,35.66,0,0,1,2.41,7.13,51.89,51.89,0,0,1,1,14.13,104.62,104.62,0,0,1-1.57,12.74l-2,11a94.37,94.37,0,0,0-1.78,16c0,1.9,0,3.38.1,4.38,0,.49.06.87.08,1.14S525.72,275.69,525.72,275.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.17,277.29a42,42,0,0,1-.38-5.92,93,93,0,0,1,1.64-16.08c.61-3.36,1.27-7,2-11a106.38,106.38,0,0,0,1.52-12.68,52.25,52.25,0,0,0-1-14,35.1,35.1,0,0,0-2.38-7,33.5,33.5,0,0,0-4-6.5,78.47,78.47,0,0,0-10.66-10.74c-3.71-3.22-7.27-6.37-10.42-9.6a131.73,131.73,0,0,1-15.23-18.52A128.28,128.28,0,0,1,484,151.3c-.87-1.7-1.51-3-1.92-4-.2-.44-.36-.78-.47-1s-.15-.35-.15-.36a2.38,2.38,0,0,1,.19.34l.52,1c.43.91,1.1,2.23,2,3.92a138.88,138.88,0,0,0,8.36,13.8,133.9,133.9,0,0,0,15.26,18.4c3.16,3.22,6.7,6.35,10.42,9.56a78.29,78.29,0,0,1,10.73,10.8,33.68,33.68,0,0,1,4.06,6.6,36,36,0,0,1,2.41,7.12,52,52,0,0,1,1,14.14,104.26,104.26,0,0,1-1.56,12.73l-2,11a95.63,95.63,0,0,0-1.79,16c0,1.9,0,3.39.11,4.39,0,.48.06.86.08,1.14S531.17,277.29,531.17,277.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38,296c-4.47-4.56-9.66-9.47-9.66-9.47l-4.38-4.6a7.08,7.08,0,0,0-.47,1.18,4.81,4.81,0,0,1-1.09,2.13c-1.12,1-3,.7-4.3,0a9.31,9.31,0,0,1-4.71-7.87,9.17,9.17,0,0,1,4.27-7.69,6.67,6.67,0,0,1,1.18-2.33c3.66-4.71,12.3-4.1,12.3-4.1l-1.3-1.83s-5.92-3.63-15.68,2.56a7,7,0,0,1-4.92,1.08,3.59,3.59,0,0,1-2.65-1.58c-1.45-2.41-.11-4.05,5.92-8s13.18-5.76,17.74-4.1a48.77,48.77,0,0,1,6.23,2.61S264,236.81,263.39,235.7c-1.85-3.22-2-6.73.06-8.17,1.31-.92,3.63-1.11,5.91,2.57,2,3.18,26.32,33.27,26.32,33.27l10,13.94L312,290.14,290.45,302l-1.8-.17A19.84,19.84,0,0,1,276.38,296Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,277.85c-1.51,1.6-4.18,1.41-6.15.41s-3.55-2.64-5.44-3.78c-5.66-3.41-13.35-2-18.84-5.67-.76-.51-1.55-1.38-1.21-2.23s1.34-.94,2.2-1l21.84-.94",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,264.66a9.13,9.13,0,0,0-2.37-.14c-1.53,0-3.73,0-6.46.08l-9.56.28-2.76.1c-.87.1-2.06-.16-3.15.87a1.83,1.83,0,0,0-.21,2,3.69,3.69,0,0,0,1.2,1.33,14.14,14.14,0,0,0,2.86,1.49c4.06,1.54,8.11,1.61,11.53,2.45a16.42,16.42,0,0,1,4.62,1.73c1.33.77,2.47,1.74,3.61,2.53,2.23,1.7,4.75,2.19,6.29,1.74s2-1.32,2-1.32a6.53,6.53,0,0,1-2.1.85,7.51,7.51,0,0,1-5.67-2,44.3,44.3,0,0,0-3.6-2.7,17.07,17.07,0,0,0-4.88-1.95c-3.55-.94-7.6-1.06-11.35-2.5a13.77,13.77,0,0,1-2.59-1.34c-.75-.52-1.15-1.26-.78-1.58s1.34-.46,2.28-.49l2.76-.14,9.55-.54c2.71-.17,4.91-.34,6.43-.48A8.21,8.21,0,0,0,294.5,264.66Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,263.16a9.1,9.1,0,0,0-3.19-2.63,7,7,0,0,0-4.35-.34,17.72,17.72,0,0,0-5.09,2.18,28.15,28.15,0,0,1-5.14,2.54,9.16,9.16,0,0,1-4.75.41,3.6,3.6,0,0,1-2.55-1.95,2.06,2.06,0,0,1-.26-1.15c.07,0,.17.39.54,1a3.43,3.43,0,0,0,2.39,1.55,9.29,9.29,0,0,0,4.39-.55,31.41,31.41,0,0,0,5-2.55,17.37,17.37,0,0,1,5.34-2.2,7.34,7.34,0,0,1,4.74.55,6.5,6.5,0,0,1,2.44,2.08C269.73,262.73,269.85,263.14,269.81,263.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,234.45a23.5,23.5,0,0,1,2.17,3.39c1.43,2.37,3.14,5.18,5,8.3l5.15,8.22a21.53,21.53,0,0,1,2.05,3.47,18.54,18.54,0,0,1-2.52-3.16c-1.46-2-3.37-4.88-5.37-8.12s-3.68-6.23-4.84-8.43A17.6,17.6,0,0,1,262.7,234.45Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,269.41c0,.07-.45.11-1.24.23a3.76,3.76,0,0,0-2.74,1.49,2,2,0,0,0,0,2,10.22,10.22,0,0,0,1.54,2.13,4.54,4.54,0,0,1,1.27,2.95,3.82,3.82,0,0,1-1.79,3,4.36,4.36,0,0,1-3.43.48,5.5,5.5,0,0,1-2.76-1.61,17.86,17.86,0,0,1-2.67-4.45,10.28,10.28,0,0,1-.88-3.37,2.39,2.39,0,0,1,.18-1.27,10.4,10.4,0,0,1,.13,1.24,12.79,12.79,0,0,0,1.09,3.17,18.94,18.94,0,0,0,2.7,4.18c1.16,1.25,3.5,2,5.2,1a3,3,0,0,0,1.44-2.33,3.85,3.85,0,0,0-1.06-2.45,10.89,10.89,0,0,1-1.57-2.32,2.59,2.59,0,0,1,.13-2.55,3.93,3.93,0,0,1,3.19-1.49A3.46,3.46,0,0,1,268.32,269.41Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.89,280.93s.35.28.51,1a3.44,3.44,0,0,1-.91,3,4.66,4.66,0,0,1-4.5,1.14,7.77,7.77,0,0,1-4.51-3.5,9.24,9.24,0,0,1-1.37-5.5,8.69,8.69,0,0,1,1.55-4.34,8.22,8.22,0,0,1,2.2-2.18c.62-.4,1-.53,1-.49a14.19,14.19,0,0,0-2.74,3,8.52,8.52,0,0,0-1.29,4.08,8.75,8.75,0,0,0,1.32,5,7.13,7.13,0,0,0,4,3.21,4.16,4.16,0,0,0,3.92-.83,3.27,3.27,0,0,0,1-2.55C262,281.32,261.83,281,261.89,280.93Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.93,285.19c0-.06.5-.56,1.67-1a7.6,7.6,0,0,1,4.94,0l-.47.52a21.14,21.14,0,0,1-1.05-2.53c-1.75-5-1.09-9.42-.9-9.36s0,4.25,1.66,9.11c.3.87.64,1.7,1,2.45l.38.84-.85-.31a8,8,0,0,0-4.55-.24A18.68,18.68,0,0,1,280.93,285.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.41,256.08c.22,0,.32,1.62-.8,3.19s-2.68,2.06-2.74,1.85,1.13-.92,2.08-2.31S262.18,256.06,262.41,256.08Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.68,354.8S359,385.29,343.74,384.15c-14.84-1.1-42.1-47.4-49-60.3-5.79-10.86-10-20.26-10-20.26l24.5-20,4,3.61L352,333.27c4.48,0,43.63-25.44,43.63-25.44s22.38-20.22,30.89-21.5,3.35,17.91,3.35,17.91Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.16,295l-37-17.64.94-.62L512,263l-35,25.86-17.12-20.77-8,10.54h0l-25.3,7.7-6,22.77L412,329.33c-8,19-7.32,40.09-1.38,59.88l0,.14c5.69,18.69,14.37,21.89,11.22,42.34-.72,4.67-4.1,34.25-4.1,34.25H554.38l-14.31-43.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7,312.33a2.9,2.9,0,0,1,.12.66c.07.48.16,1.11.27,1.9.21,1.71.51,4.1.88,7.05V322a217.8,217.8,0,0,0-6.31,24.75c-.9,4.79-1.53,9.38-1.9,13.58a96.86,96.86,0,0,0-.35,11.17A74.82,74.82,0,0,0,410,379c.12.85.22,1.52.3,2a3.75,3.75,0,0,1,.07.71,2.86,2.86,0,0,1-.17-.69c-.1-.52-.24-1.19-.4-2a64.62,64.62,0,0,1-.8-7.53,93.46,93.46,0,0,1,.24-11.23c.35-4.22,1-8.83,1.86-13.63a194,194,0,0,1,6.49-24.77V322c-.3-3-.54-5.35-.72-7.07-.07-.79-.12-1.43-.17-1.91A3.08,3.08,0,0,1,416.7,312.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.75,464.92a2.45,2.45,0,0,1-.07-.41c0-.3-.09-.71-.16-1.23-.13-1.11-.32-2.7-.56-4.73q-.18-1.55-.39-3.42t-.33-4.08c-.12-1.47-.25-3-.38-4.69s-.19-3.43-.3-5.27-.19-3.78-.29-5.8-.11-4.12-.16-6.29c-.16-4.35-.08-9-.11-13.89.11-9.78.49-20.53,1.16-31.79,1.39-22.54,3.48-42.87,5-57.58.76-7.34,1.38-13.28,1.82-17.42l.51-4.74c.06-.52.11-.92.15-1.23a1.72,1.72,0,0,1,.07-.41,2.66,2.66,0,0,1,0,.42q0,.45-.09,1.23c-.1,1.12-.24,2.71-.42,4.75-.39,4.14-1,10.09-1.65,17.43-1.4,14.72-3.43,35.06-4.82,57.58-.67,11.26-1.06,22-1.2,31.77,0,4.88-.08,9.53.06,13.87,0,2.17.09,4.27.13,6.29s.17,3.94.26,5.79.13,3.6.26,5.26.23,3.23.34,4.69.2,2.83.29,4.09.24,2.39.34,3.42c.2,2,.36,3.63.47,4.74l.1,1.23A2.66,2.66,0,0,1,468.75,464.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.43,289.92a12.42,12.42,0,0,1-.89,1.09c-.58.7-1.35,1.78-2.27,3.16-1.83,2.77-4.2,6.8-6.72,11.52l-.21.39-.23-.37c-1-1.57-2-3.28-2.93-5-3.24-6-5.91-11.48-8-15.39-1-2-1.89-3.53-2.49-4.61l-.7-1.25a1.76,1.76,0,0,1-.21-.45,2,2,0,0,1,.3.4l.78,1.19c.66,1.06,1.58,2.6,2.65,4.55,2.17,3.87,4.88,9.37,8.11,15.31,1,1.77,1.95,3.46,2.91,5l-.44,0A120.93,120.93,0,0,1,473,294a30.58,30.58,0,0,1,2.41-3.09,8.83,8.83,0,0,1,.74-.75C476.32,290,476.42,289.91,476.43,289.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.14,276.78a2.77,2.77,0,0,1-.45.49l-1.35,1.34c-1.2,1.14-3,2.78-5.15,4.76-4.4,4-10.56,9.33-17.53,15.07-2.1,1.73-4.16,3.39-6.14,4.94s-3.87,3-5.75,4.24l-.23.15-.11-.26a47.86,47.86,0,0,1-1.94-7c-.47-2.1-.93-3.91-1.42-5.38a20.41,20.41,0,0,0-1.38-3.31,11.87,11.87,0,0,1-.63-1.12,1.45,1.45,0,0,1,.21.26,7.24,7.24,0,0,1,.54.79,17.44,17.44,0,0,1,1.52,3.29,51.79,51.79,0,0,1,1.53,5.39,49.88,49.88,0,0,0,2,6.88l-.34-.1c1.83-1.22,3.72-2.69,5.69-4.25s4-3.22,6.12-4.94c7-5.74,13.16-11.06,17.62-15l5.25-4.63,1.42-1.27A3.77,3.77,0,0,1,520.14,276.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.5,297.19a9.11,9.11,0,0,1-1.32,1c-.43.3-1,.66-1.54,1.13s-1.27,1-1.95,1.6-1.47,1.3-2.23,2.1-1.55,1.66-2.36,2.59a45,45,0,0,0-4.52,6.64,46,46,0,0,0-3.14,7.39c-.34,1.19-.69,2.31-.9,3.4s-.42,2.08-.55,3-.21,1.77-.29,2.51-.11,1.39-.12,1.91a10.64,10.64,0,0,1-.1,1.63,9.22,9.22,0,0,1-.1-1.63,15.93,15.93,0,0,1,0-1.92,25.46,25.46,0,0,1,.21-2.54,27.55,27.55,0,0,1,.5-3.05c.19-1.1.53-2.24.86-3.45a43.65,43.65,0,0,1,3.15-7.5,43,43,0,0,1,4.6-6.7c.83-.93,1.61-1.83,2.42-2.59s1.57-1.46,2.3-2.07,1.42-1.1,2-1.55a17.09,17.09,0,0,1,1.6-1.07A10.19,10.19,0,0,1,554.5,297.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.92,376.84s-8.07-35.26-11.12-48.68C573,302.8,556.16,295,556.16,295l-20.3,55.19,12.56,57.65-55.78-8-9.44-2.38-6.8,32.37L494.08,437s63,23.71,81.58,21.47,22.33-23.24,22.41-31.89C598.2,411.79,589.92,376.84,589.92,376.84Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.55,382.05l-23.47-47.43a9.48,9.48,0,0,0-8.51-5.26h-59a2.87,2.87,0,0,0-2.55,4.22L393,407.49a6.44,6.44,0,0,0,5.66,3.36h61.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.13,381.16a1.29,1.29,0,0,1-.15-.26l-.42-.78c-.38-.73-.9-1.75-1.56-3.05-1.36-2.69-3.28-6.53-5.66-11.26s-5.2-10.44-8.33-16.73l-4.9-9.89c-.43-.85-.85-1.74-1.29-2.57a8.4,8.4,0,0,0-7.1-4.29l-41.57-.08-12.6-.09-3.43,0-.89,0-.3,0,.3,0,.89,0,3.43-.05,12.6-.08,41.58-.07a8.86,8.86,0,0,1,7.54,4.56c.46.88.86,1.74,1.29,2.6,1.7,3.43,3.33,6.74,4.88,9.9,3.09,6.31,5.88,12,8.23,16.77L440.18,377c.63,1.31,1.12,2.35,1.47,3.09.16.33.28.6.37.81A1.27,1.27,0,0,1,442.13,381.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.25,345.41a2.89,2.89,0,0,0,1.18,3.75,2.44,2.44,0,0,0,3.84-2.83c-.38-.95-2.1-2.47-3.34-2.13C391.93,344.2,390.62,344.64,390.25,345.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.53,396.18s-6-8.61-8.41-11.3S453,372.76,453,372.76s-7.06-9.49-8.15-9.49-4.52.61-3.6,5A67.67,67.67,0,0,0,445.15,381l-33.31-1.1c-2,0-4.82.54-5.6,2.44-.95,2.34,1.34,3.93,2.81,4.66,2,1,8,2.64,12.14,3.73-.06.11-2.76,5.26,1,7.91s4,3.16,4,3.16.18,5.33,1.81,7.49,19.26,11.15,19.26,11.15,11.28,3.3,17,3,11.56,2.94,12.2,3.11,6.2-26.28,6.2-26.28Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.13,381.16c0,.31,4,.47,8.8,1s8.84.77,8.86.43-3.86-1-8.75-1.52S442.12,380.87,442.13,381.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.31,394.94c.1-.33-5.61-1.88-12.78-2.69-3.58-.45-6.82-.77-9.16-1s-3.79-.44-3.82-.29,1.37.61,3.7,1.06,5.57.9,9.14,1.35C440.54,394.15,446.24,395.19,446.31,394.94Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.31,405.1c0-.32-4.56-.46-10.07-1.41s-9.86-2.3-10-2,4.15,2.13,9.78,3.08S446.33,405.38,446.31,405.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.42,416.48c.3,0,.76-1.17,1-2.72s.22-2.86-.08-2.91-.76,1.17-1,2.73S444.12,416.43,444.42,416.48Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.23,402.85c.31,0,.47-1,1-2.09s1.21-1.83,1-2.09-1.37.23-2,1.61S446.93,402.91,447.23,402.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8,389.21c.31,0,.63-.62,1-1.35s.7-1.39.49-1.62-1,.19-1.48,1.13S450.5,389.19,450.8,389.21Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.42,454.05l-.36-.06-1-.24c-.92-.21-2.3-.51-4.06-1-3.53-.93-8.63-2.49-15-4.56-12.8-4.14-30.74-10.42-51.6-18.11l-.2-.07,0-.21c2.1-10,4.4-21,6.79-32.37l.05-.27.27.07,5.94,1.49,3.5.88h0l55.59,7.56-.25.27c-3.49-16.31-6.4-29.88-8.44-39.39l-2.32-11-.6-2.91c-.13-.65-.18-1-.18-1s.1.34.25,1,.38,1.64.66,2.89l2.45,11,8.62,39.35.07.31-.32,0-55.6-7.49h0l-3.49-.88-5.95-1.5.32-.2c-2.4,11.4-4.71,22.34-6.82,32.37l-.15-.28c20.84,7.72,38.76,14.06,51.52,18.28,6.38,2.11,11.47,3.71,15,4.69,1.75.53,3.11.86,4,1.09l1,.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.5,418.46c-.08,0-.61-.91-1.68-2.3a24.18,24.18,0,0,0-4.86-4.74,23.77,23.77,0,0,0-6-3.16c-1.65-.59-2.73-.8-2.71-.89s.28,0,.77.06a14.09,14.09,0,0,1,2,.48,20.73,20.73,0,0,1,6.21,3.09,21,21,0,0,1,4.85,4.94,14.47,14.47,0,0,1,1.08,1.81C563.43,418.19,563.53,418.44,563.5,418.46Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficer);
export default __webpack_public_path__ + "static/media/officer.b0c2dbecbc8b5e44359534afdd276a61.svg";
export { ForwardRef as ReactComponent };